export const loginLang = {
    en: {
        "field.label.login_id": "Login Id",
        "field.label.password": "Password",
        "button.label.login": "Login",
        "field.label.sign_in": "Login",
        "field.label.forgot_password": "Forgot Password",
        "field.label.patient_login_with_mobile": "Login With OTP",
        "field.label.login_with_pin": "Login With PIN",
        "field.label.Enter_mPin": "Enter mPin",
        "field.label.set_mPin": "Set mPin",
        "field.label.create_mPin": "Create mPin",
        "button.label.save_mPin": "Save mPin & Login",
        "field.label.confirm_mPin": "Confirm mPin",
        "field.label.forgot_reset_mPin": "Forgot/Reset mPin",
        "field.label.terms_of_service": "Terms of Service and Data Privacy Notice",
        "field.label.user_manual": "User Manual",
        "field.label.new_to_the_platform": "New to the platform ?",
        "field.label.sign_up": "Register New User",
        "field.label.account_url": "Account Url",
        "field.label.check_app_status": "Check Appstatus..",
        "field.label.new_user_registration": "New user registration",
        "field.label.click_hare_for_new_user_registration": "Click here for new Registration",
        "field.label.install_lite_app": "Install lite app",
        "field.label.full_name": "Full Name",
        "field.label.mobilenumber": "Mobile Number",
        "field.label.accounturl": "Account Url",
        "button.label.next": "Next",
        "field.label.guest_name": "Guest Name (Paying By)",
        "field.label.guest_mobile_number": "Mobile Number (Self)",
        "field.label.email_address": "Email Address",
        "field.label.online_payment": "Online IP Payment",
        "field.label.reset_password": "Reset Password",
        "button.generate_otp": "Generate OTP",
        "field.label.select": "Select",
        "field.hint.old_password": "Enter Old Password",
        "button.cancel": "Cancel",
        "button.update": "Update",
        "field.label.mobile_number": "Mobile Number",
        "field.label.new_password": "New Password",
        "field.label.old_password": "Old Password",
        "field.hint.new_password": "New Password",
        "field.label.confirm_new_password": "Confirm New Password",
        "field.hint.confirm_new_password": "Confirm New Password",
        "field.label.confirm_password": "Confirm Password",
        "field.label.Enter_otp": "Enter 6 digit One Time Password (OTP) sent on registered mobile number/email.",
        "field.label.enter_otp": "We have sent you 6 digit verification code on your mobile to verify contact details.",
        "field.label.Enter_OTP": "Enter 6 digit One Time Password (OTP) sent on registered mobile number.",
        "field.label.resend_code": "Resend Code",
        "field.label.resend_OTP": "Resend OTP",
        "field.label.invalid_otp": "Invalid OTP",
        "field.label.invalid_user": "invalid user",
        "field.label.seconds": "sec",
        "field.label.UHID": "UHID",
        "placeholder.kiosk_login_id": "Login id/UHID",
        "placeholder.kiosk_password": "Password/Mobile No.",
        "field.label.resend_OTP_in_timer_sec": "Resend OTP in ",
        "field.label.mobile_number_digits.": "Mobile Number cannot be less than 10 digits.",
        "field.label.alphabet_cannot_be_accepted": "Alphabet cannot be accepted",
        "required.telecom_code": "Telecom Code Required",
        "field.label.login_cannot_be_2": "Login Id cannot be less than 2 Character.",
        "field.label.account_Url_required": "Account Url required atleast 2 characters.",
        "field.label.account_Url_not_exceed": "Account Url can not exceed 255 characters.",
        "field.label.only_alphabet_hyphen_dot_numbers": "Only Alphabet, hyphen, dot and numbers are allowed.",
        "field.label.password_cannot_be_6": "Password cannot be less than 6 Character.",
        "field.label.confirm_password_required": "Confirm Password is required",
        "field.label.passwords_match": "Please make sure your passwords match",
        "field.label.type_the_characters": "Type the characters above:",
        "field.label.captcha_is_required": "Captcha is required",
        "field.label.required.password": "Password Required",
        "button.change_password": "Change Password",
        "field.label.please_turn_on_notification": "For better experience please turn on notification",
        "dam": "Please contact your administrator and get this device approved.",
        "button.manage_user_pin": "Generate Pin",
        "button.update_landing_url": "Update Landing Url",
        "button.support": "Support",
        "pagename.list.setDefaultFacility": "Set Default Facility",
        "button.check_my_internet_speed": "Check My Internet Speed",
        "button.check_screen_shortcuts": "Shortcut Keys",
        "button.install_app": "Install App",
        "button.logout": "Logout",
        "field.hint.search_menu": "Search menu",
        "button.change_login_id": "Change Login-Id",
        "field.label.search_role": "Search Role",
        "field.label.quick_otp": "Enter 6 digit One Time Password (OTP) sent on registered email.",
        "field.label.quick_otp_mob": "Enter 6 digit One Time Password (OTP) sent on registered Mobile No.",
        "field.label.quick_download_verification_code": "Enter verification code to continue Download...",
        "nto": "Network timeout, Please check your internet connection.",
        "cffe": "Error while formatting the CSV",
        "idnf": "Download not found",
        "otpsuc": "OTP sent successfully on your registered email. ",
        "otpsucMob": "OTP sent successfully on your registered Mobile No. ",
        "field.label.enter_otp_normal": "Enter OTP",
        "Patient": "Patient",
        "logasemp": "Login via SSO",
        "logasoth": "Login as Others",
        "care_pro": "Care Provider",
        "USER_NOT_EXISTS_IN_KX": "The user does not exist",
        "Or": "Or"
    },
    fr: {
        "field.label.login_id": "Identifiant de connexion",
        "field.label.password": "Mot de passe",
        "button.label.login": "Se connecter",
        "field.label.sign_in": "Se connecter",
        "field.label.forgot_password": "Mot de passe oublié",
        "field.label.patient_login_with_mobile": "Connectez-vous avec OTP",
        "field.label.terms_of_service": "Conditions d'utilisation",
        "field.label.new_to_the_platform": "Nouveau sur la plateforme ?",
        "field.label.sign_up": "Enregistrer un nouvel utilisateur",
        "field.label.account_url": "URL du compte",
        "field.label.check_app_status": "Vérifiez le statut de l'application.",
        "field.label.new_user_registration": "Enregistrement d'un nouvel utilisateur",
        "field.label.click_hare_for_new_user_registration": "Cliquez ici pour une nouvelle inscription",
        "field.label.install_lite_app": "Installer l'application allégée",
        "field.label.full_name": "Nom et prénom",
        "field.label.mobilenumber": "Numéro de portable",
        "field.label.accounturl": "URL du compte",
        "button.label.next": "Suivant",
        "field.label.email_address": "Adresse e-mail",
        "field.label.reset_password": "réinitialiser le mot de passe",
        "button.generate_otp": "Générer un OTP",
        "field.label.select": "Sélectionner",
        "field.hint.old_password": "Entrez l'ancien mot de passe",
        "button.cancel": "Annuler",
        "button.update": "Mise à jour",
        "field.label.mobile_number": "Numéro de portable",
        "field.label.new_password": "nouveau mot de passe",
        "field.label.old_password": "ancien mot de passe",
        "field.hint.new_password": "nouveau mot de passe",
        "field.label.confirm_new_password": "Confirmer le nouveau mot de passe",
        "field.hint.confirm_new_password": "Confirmer le nouveau mot de passe",
        "field.label.confirm_password": "Confirmez le mot de passe",
        "field.label.Enter_otp": "Entrez le mot de passe à usage unique (OTP) à 6 chiffres envoyé sur le numéro de mobile/e-mail enregistré.",
        "field.label.enter_otp": "Nous vous avons envoyé un code de vérification à 6 chiffres sur votre mobile pour vérifier les coordonnées.",
        "field.label.Enter_OTP": "Entrez le mot de passe à usage unique (OTP) à 6 chiffres envoyé sur le numéro de mobile enregistré.",
        "field.label.resend_code": "Renvoyer le code",
        "field.label.resend_OTP": "Renvoyer OTP",
        "field.label.invalid_otp": "OTP invalide",
        "field.label.invalid_user": "utilisateur invalide",
        "field.label.seconds": "seconde",
        "field.label.UHID": "UHID",
        "field.label.resend_OTP_in_timer_sec": "Renvoyer OTP dans",
        "field.label.mobile_number_digits.": "Le numéro de mobile ne peut pas comporter moins de 10 chiffres.",
        "field.label.alphabet_cannot_be_accepted": "L'alphabet ne peut pas être accepté",
        "field.label.login_cannot_be_2": "L’identifiant de connexion ne peut pas être inférieur à 2 caractères.",
        "field.label.account_Url_required": "L'URL du compte nécessite au moins 2 caractères.",
        "field.label.account_Url_not_exceed": "L'URL du compte ne peut pas dépasser 255 caractères.",
        "field.label.only_alphabet_hyphen_dot_numbers": "Seuls l'alphabet, le trait d'union, le point et les chiffres sont autorisés.",
        "field.label.password_cannot_be_6": "Le mot de passe ne peut pas contenir moins de 6 caractères.",
        "field.label.confirm_password_required": "Confirmer que le mot de passe est requis",
        "field.label.passwords_match": "Merci de vérifier que vos mots de passe correspondent",
        "field.label.type_the_characters": "Tapez les caractères ci-dessus :",
        "field.label.captcha_is_required": "Un captcha est obligatoire",
        "field.label.required.password": "Mot de passe requis",
        "button.change_password": "Changer le mot de passe",
        "field.label.please_turn_on_notification": "Pour une meilleure expérience, veuillez activer la notification",
        "dam": "Veuillez contacter votre administrateur et faire approuver cet appareil.",
        "button.manage_user_pin": "Générer une épingle",
        "button.update_landing_url": "Mettre à jour l'URL de destination",
        "button.support": "Soutien",
        "pagename.list.setDefaultFacility": "Définir l'installation par défaut",
        "button.check_my_internet_speed": "Vérifier ma vitesse Internet",
        "button.check_screen_shortcuts": "Raccourcis claviers",
        "button.install_app": "Installer l'application",
        "button.logout": "Se déconnecter",
        "field.hint.search_menu": "Menu de recherche",
        "button.change_login_id": "Modifier l'identifiant de connexion",
        "field.label.search_role": "Rôle de recherche",
        "field.label.quick_otp": "Entrez le mot de passe à usage unique (OTP) à 6 chiffres envoyé par e-mail enregistré.",
        "field.label.quick_download_verification_code": "Entrez le code de vérification pour continuer le téléchargement...",
        "nto": "Délai d'expiration du réseau, veuillez vérifier votre connexion Internet.",
        "cffe": "Erreur lors du formatage du CSV",
        "idnf": "Téléchargement introuvable",
        "otpsuc": "OTP envoyé avec succès sur votre e-mail enregistré.",
        "field.label.enter_otp_normal": "Entrez OTP"
    },
    hi: {
        "field.label.password": "पासवर्ड",
        "field.label.login_id": "लॉगइन आईडी",
        "button.label.login": "लॉगइन",
        "field.label.sign_in": "लॉगइन",
        "field.label.forgot_password": "पासवर्ड भूल गए",
        "field.label.patient_login_with_mobile": "मोबाइल के साथ रोगी लॉगिन",
        "field.label.terms_of_service": "सेवा की शर्तें",
        "field.label.new_to_the_platform": "मंच पर नया है?",
        "field.label.sign_up": "साइन अप करें",
        "placeholder.kiosk_login_id": "लॉगिन आईडी/यूएचआईडी",
        "placeholder.kiosk_password": "पासवर्ड/मोबाइल नंबर",
        "field.label.email_address": "ई - मेल एड्रेस",
        "field.label.account_url": "अकाउंट यूआरएल",
        "field.label.check_app_status": "ऐप की स्थिति जांचें..",
        "field.label.install_lite_app": "लाइट ऐप इंस्टॉल करें",
        "field.label.new_user_registration": "नया उपयोगकर्ता पंजीकरण",
        "field.label.full_name": "पूरा नाम",
        "field.label.mobilenumber": "मोबाईल नम्बर",
        "field.label.accounturl": "अकाउंट यूआरएल",
        "button.label.next": "अगला",
        "field.label.mobile_number": "मोबाईल नम्बर",
        "field.label.Enter_otp": "",
        "field.label.enter_otp": "",
        "field.label.Enter_OTP": "",
        "field.label.UHID": "उहिद",
        "field.label.select": "चयन करें",
        "field.hint.search_menu": "खोज मेन्यू",
        "field.label.search_role": "खोज भूमिका",
        "field.label.click_hare_for_new_user_registration": "नए रजिस्ट्रेशन के लिए यहां क्लिक करें"
    },
    vi: {
        "field.label.password": "Mật khẩu",
        "field.label.login_id": "ID đăng nhập",
        "button.label.login": "Đăng nhập",
        "field.label.sign_in": "Đăng nhập",
        "field.label.forgot_password": "Quên mật khẩu",
        "field.label.patient_login_with_mobile": "Đăng nhập bằng điện thoại di động",
        "field.label.terms_of_service": "Điều khoản dịch vụ",
        "field.label.new_to_the_platform": "Bạn mới đến bục giảng?",
        "field.label.sign_up": "Đăng ký",
        "field.label.email_address": "Địa chỉ email",
        "field.label.account_url": "URL tài khoản",
        "field.label.check_app_status": "Kiểm tra trạng thái ứng dụng..",
        "field.label.install_lite_app": "Cài đặt ứng dụng Lite",
        "field.label.new_user_registration": "Đăng Ký Người Dùng Mới",
        "field.label.full_name": "Tên đầy đủ",
        "field.label.mobilenumber": "Số điện thoại di động",
        "field.label.accounturl": "URL tài khoản",
        "button.label.next": "Tiếp theo",
        "field.label.reset_password": "Đặt lại mật khẩu",
        "button.generate_otp": "Nhận mã OTP",
        "field.label.mobile_number": "Số điện thoại di động",
        "field.label.Enter_otp": "Nhập 6 chữ số Mật khẩu một lần (OTP) được gửi trên số điện thoại di động đã đăng ký.",
        "field.label.enter_otp": "Chúng tôi đã gửi cho bạn mã xác minh 6 chữ số trên điện thoại di động của bạn. Nhập mã để xác minh chi tiết liên hệ.",
        "field.label.Enter_OTP": "Nhập 6 chữ số Mật khẩu một lần (OTP) được gửi trên số điện thoại di động đã đăng ký.",
        "field.label.resend_code": "Gửi lại mã",
        "field.label.select": "Chọn",
        "field.label.invalid_otp": "Mã OTP không hợp lệ",
        "field.label.seconds": "giây",
        "field.label.resend_OTP_in_timer_sec": "Gửi lại OTP trong {{timer}} ",
        "field.label.resend_OTP": "Gửi lại OTP",
        "field.label.invalid_user": "người dùng không hợp lệ",
        "field.label.mobile_number_digits.": "Số điện thoại di động không được nhỏ hơn 10 chữ số.",
        "field.label.alphabet_cannot_be_accepted": "Bảng chữ cái không thể được chấp nhận",
        "field.label.login_cannot_be_2": "Id đăng nhập không thể nhỏ hơn 2 ký tự.",
        "field.label.account_Url_required": "Url tài khoản yêu cầu ít nhất 2 ký tự.",
        "field.label.account_Url_not_exceed": "Url tài khoản không được vượt quá 255 ký tự.",
        "field.label.only_alphabet_hyphen_dot_numbers": "Chỉ cho phép Bảng chữ cái, dấu gạch nối, dấu chấm và số.",
        "field.label.password_cannot_be_6": "Mật khẩu không thể nhỏ hơn 6 ký tự.",
        "field.label.confirm_password_required": "Xác nhận mật khẩu là bắt buộc",
        "field.label.passwords_match": "Hãy đảm bảo mật khẩu của bạn khớp",
        "field.label.type_the_characters": "Nhập các ký tự trên:",
        "field.label.captcha_is_required": "Captcha là bắt buộc",
        "field.label.UHID": "UHID",
        "field.label.please_turn_on_notification": "Vui lòng bật thông báo để có trải nghiệm tốt hơn",
        "field.hint.search_menu": "Thanh tìm kiếm",
        "field.label.search_role": "Vai trò tìm kiếm"
    },
    ar: {
        "field.label.login_id": "معرف تسجيل الدخول",
        "field.label.password": "كلمة المرور",
        "button.label.login": "تسجيل الدخول",
        "field.label.sign_in": "تسجيل الدخول",
        "field.label.forgot_password": "نسيت كلمة المرور",
        "field.label.patient_login_with_mobile": "تسجيل الدخول باستخدام OTP",
        "field.label.login_with_pin": "الدخول بالرقم السري",
        "field.label.terms_of_service": "شروط الخدمة",
        "field.label.user_manual": "دليل المستخدم",
        "field.label.new_to_the_platform": "هل أنت جديد على المنصة؟",
        "field.label.sign_up": "تسجيل مستخدم جديد",
        "field.label.account_url": "عنوان URL للحساب",
        "field.label.check_app_status": "تحقق من حالة التطبيق..",
        "field.label.new_user_registration": "تسجيل مستخدم جديد",
        "field.label.install_lite_app": "قم بتثبيت تطبيق lite",
        "field.label.full_name": "الاسم الكامل",
        "field.label.mobilenumber": "رقم الهاتف",
        "field.label.accounturl": "عنوان URL للحساب",
        "button.label.next": "التالي",
        "field.label.email_address": "عنوان البريد الإلكتروني",
        "field.label.reset_password": "تعيين كلمة المرور",
        "button.generate_otp": "توليد كلمة المرور",
        "field.label.select": "حدد",
        "field.hint.old_password": "أدخل كلمة المرور القديمة",
        "button.cancel": "إلغاء",
        "button.update": "تحديث",
        "field.label.mobile_number": "رقم الهاتف",
        "field.label.new_password": "كلمة مرور جديدة",
        "field.label.old_password": "كلمة المرور القديمة",
        "field.hint.new_password": "كلمة مرور جديدة",
        "field.label.confirm_new_password": "تأكيد كلمة المرور الجديدة",
        "field.hint.confirm_new_password": "تأكيد كلمة المرور الجديدة",
        "field.label.confirm_password": "تأكيد كلمة المرور",
        "field.label.Enter_otp": "أدخل كلمة المرور لمرة واحدة (OTP) المكونة من 6 أرقام المرسلة على رقم الهاتف المحمول/البريد الإلكتروني المسجل.",
        "field.label.enter_otp": "لقد أرسلنا لك رمز التحقق المكون من 6 أرقام على هاتفك المحمول للتحقق من تفاصيل الاتصال.",
        "field.label.Enter_OTP": "أدخل كلمة المرور لمرة واحدة (OTP) المكونة من 6 أرقام المرسلة على رقم الهاتف المحمول المسجل.",
        "field.label.resend_code": "إعادة إرسال الكود",
        "field.label.resend_OTP": "إعادة إرسال الجزء العلوي",
        "field.label.invalid_otp": "كلمة مرور لمرة",
        "field.label.invalid_user": "مستخدم غير صالح",
        "field.label.seconds": "ثانية",
        "field.label.UHID": "أوهيد",
        "field.label.resend_OTP_in_timer_sec": "إعادة إرسال OTP في ",
        "field.label.mobile_number_digits.": "لا يمكن أن يكون رقم الهاتف المحمول أقل من 10 أرقام.",
        "field.label.alphabet_cannot_be_accepted": "لا يمكن قبول الأبجدية",
        "field.label.login_cannot_be_2": "لا يمكن أن يكون معرف تسجيل الدخول أقل من حرفين.",
        "field.label.account_Url_required": "يتطلب عنوان Url للحساب حرفين على الأقل.",
        "field.label.account_Url_not_exceed": "لا يمكن أن يتجاوز عنوان URL للحساب 255 حرفًا.",
        "field.label.only_alphabet_hyphen_dot_numbers": "يُسمح فقط بالأبجدية والواصلة والنقطة والأرقام.",
        "field.label.password_cannot_be_6": "لا يمكن أن تكون كلمة المرور أقل من 6 أحرف.",
        "field.label.confirm_password_required": "تأكيد كلمة المرور مطلوبة",
        "field.label.passwords_match": "يرجى التأكد من تطابق كلمات المرور الخاصة بك",
        "field.label.type_the_characters": "اكتب الأحرف أعلاه:",
        "field.label.captcha_is_required": "مطلوب اختبار CAPTCHA",
        "button.change_password": "تغيير كلمة المرور",
        "field.label.please_turn_on_notification": "للحصول على تجربة أفضل، يرجى تشغيل الإشعار",
        "dam": "يرجى الاتصال بالمسؤول والحصول على الموافقة على هذا الجهاز.",
        "button.manage_user_pin": "توليد دبوس",
        "button.update_landing_url": "تحديث عنوان URL المقصودة",
        "button.support": "دعم",
        "pagename.list.setDefaultFacility": "تعيين مرفق افتراضي",
        "button.check_my_internet_speed": "تحقق من سرعة الإنترنت",
        "button.check_screen_shortcuts": "مفاتيح الاختصار",
        "button.install_app": "تثبيت التطبيق",
        "button.logout": "تسجيل الخروج",
        "field.hint.search_menu": "قائمة البحث",
        "field.label.search_role": "دور البحث",
        "field.label.click_hare_for_new_user_registration": "انقر هنا للحصول على تسجيل جديد",
        "Or": "أو"
    },
    km: {
        "field.label.login_id": "លេខសម្គាល់ចូល",
        "field.label.password": "ពាក្យសម្ងាត់",
        "button.label.login": "ចូល",
        "field.label.sign_in": "ចូល",
        "field.label.forgot_password": "ភ្លេចពាក្យសម្ងាត់",
        "field.label.patient_login_with_mobile": "ចូលដោយប្រើ OTP",
        "field.label.terms_of_service": "លក្ខខណ្ឌប្រើប្រាស់",
        "field.label.new_to_the_platform": "ថ្មីសម្រាប់វេទិកា?",
        "field.label.sign_up": "ចុះឈ្មោះអ្នកប្រើប្រាស់ថ្មី",
        "field.label.account_url": "គណនី Url",
        "field.label.check_app_status": "ពិនិត្យស្ថានភាពកម្មវិធី..",
        "field.label.new_user_registration": "ការចុះឈ្មោះអ្នកប្រើប្រាស់ថ្មី",
        "field.label.click_hare_for_new_user_registration": "ចុចទីនេះសម្រាប់ការចុះឈ្មោះថ្មី",
        "field.label.install_lite_app": "ដំឡើងកម្មវិធី lite",
        "field.label.full_name": "ឈ្មោះពេញ",
        "field.label.mobilenumber": "លេខទូរស័ព្ទ",
        "field.label.accounturl": "គណនី Url",
        "button.label.next": "បន្ទាប់",
        "field.label.email_address": "អាសយដ្ឋានអ៊ីមែល",
        "field.label.reset_password": "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
        "button.generate_otp": "បង្កើត OTP",
        "field.label.select": "ជ្រើសរើស",
        "field.hint.old_password": "បញ្ចូលពាក្យសម្ងាត់ចាស់",
        "button.cancel": "បោះបង់",
        "button.update": "ធ្វើបច្ចុប្បន្នភាព",
        "field.label.mobile_number": "លេខទូរស័ព្ទ",
        "field.label.new_password": "ពាក្យសម្ងាត់ថ្មី",
        "field.label.old_password": "ពាក្យសម្ងាត់ចាស់",
        "field.hint.new_password": "ពាក្យសម្ងាត់ថ្មី",
        "field.label.confirm_new_password": "បញ្ជាក់ពាក្យសម្ងាត់ថ្មី",
        "field.hint.confirm_new_password": "បញ្ជាក់ពាក្យសម្ងាត់ថ្មី",
        "field.label.confirm_password": "បញ្ជាក់ពាក្យសម្ងាត់",
        "field.label.Enter_otp": "បញ្ចូល 6 ខ្ទង់ ពាក្យសម្ងាត់តែម្តង (OTP) ដែលបានផ្ញើនៅលើលេខទូរស័ព្ទ/អ៊ីមែលដែលបានចុះឈ្មោះ។",
        "field.label.enter_otp": "យើងបានផ្ញើលេខកូដផ្ទៀងផ្ទាត់ 6 ខ្ទង់ឱ្យអ្នកនៅលើទូរសព្ទរបស់អ្នក ដើម្បីផ្ទៀងផ្ទាត់ព័ត៌មានលម្អិតទំនាក់ទំនង។",
        "field.label.Enter_OTP": "បញ្ចូល 6 ខ្ទង់ ពាក្យសម្ងាត់តែមួយដង (OTP) ដែលបានផ្ញើនៅលើលេខទូរស័ព្ទដែលបានចុះឈ្មោះ។",
        "field.label.resend_code": "ផ្ញើលេខកូដឡើងវិញ",
        "field.label.resend_OTP": "ផ្ញើ OTP ឡើងវិញ",
        "field.label.invalid_otp": "OTP មិនត្រឹមត្រូវ",
        "field.label.invalid_user": "អ្នកប្រើប្រាស់មិនត្រឹមត្រូវ",
        "field.label.seconds": "វិនាទី",
        "field.label.UHID": "UHID",
        "field.label.resend_OTP_in_timer_sec": "ផ្ញើ OTP ឡើងវិញក្នុង",
        "field.label.mobile_number_digits": "លេខទូរស័ព្ទមិនអាចតិចជាង 10 ខ្ទង់ទេ។",
        "field.label.alphabet_cannot_be_accepted": "អក្ខរក្រមមិនអាចទទួលយកបានទេ",
        "field.label.login_cannot_be_2": "លេខសម្គាល់ចូលមិនអាចតិចជាង 2 តួអក្សរ។",
        "field.label.account_Url_required": "គណនី Url ទាមទារយ៉ាងហោចណាស់ 2 តួអក្សរ។",
        "field.label.account_Url_not_exceed": "គណនី Url មិនអាចលើសពី 255 តួអក្សរ។",
        "field.label.only_alphabet_hyphen_dot_numbers": "មានតែអក្ខរក្រម សហសញ្ញា ចំនុច និងលេខប៉ុណ្ណោះដែលត្រូវបានអនុញ្ញាត។",
        "field.label.password_cannot_be_6": "ពាក្យសម្ងាត់មិនអាចតិចជាង 6 តួអក្សរ។",
        "field.label.confirm_password_required": "បញ្ជាក់ពាក្យសម្ងាត់គឺចាំបាច់",
        "field.label.passwords_match": "សូមប្រាកដថាពាក្យសម្ងាត់របស់អ្នកត្រូវគ្នា",
        "field.label.type_the_characters": "វាយអក្សរខាងលើ៖",
        "field.label.captcha_is_required": "ទាមទារ Captcha",
        "field.label.required.password": "ត្រូវការពាក្យសម្ងាត់",
        "button.change_password": "ប្តូរពាក្យសម្ងាត់",
        "field.label.please_turn_on_notification": "សម្រាប់បទពិសោធន៍កាន់តែប្រសើរ សូមបើកការជូនដំណឹង",
        "dam": "សូមទាក់ទងអ្នកគ្រប់គ្រងរបស់អ្នក ហើយទទួលបានការយល់ព្រមពីឧបករណ៍នេះ។",
        "button.manage_user_pin": "បង្កើតលេខសម្ងាត់",
        "button.update_landing_url": "អាប់ដេត Landing Url",
        "button.support": "គាំទ្រ",
        "pagename.list.setDefaultFacility": "កំណត់ឧបករណ៍លំនាំដើម",
        "button.check_my_internet_speed": "ពិនិត្យល្បឿនអ៊ីនធឺណិតរបស់ខ្ញុំ",
        "button.check_screen_shortcuts": "គ្រាប់ចុចផ្លូវកាត់",
        "button.install_app": "ដំឡើងកម្មវិធី",
        "button.logout": "ចេញ",
        "field.hint.search_menu": "ម៉ឺនុយស្វែងរក",
        "button.change_login_id": "ផ្លាស់ប្តូរលេខសម្គាល់ការចូល",
        "field.label.search_role": "តួនាទីស្វែងរក",
        "field.label.enter_otp_normal": "បញ្ចូល OTP"
    },
    pa: {
        "field.label.login_id": "ਲੌਗਇਨ ਆਈਡੀ",
        "field.label.password": "ਪਾਸਵਰਡ",
        "button.label.login": "ਲਾਗਿਨ",
        "field.label.sign_in": "ਲਾਗਿਨ",
        "field.label.forgot_password": "ਪਾਸਵਰਡ ਭੁੱਲ ਗਏ",
        "field.label.patient_login_with_mobile": "OTP ਨਾਲ ਲੌਗਇਨ ਕਰੋ",
        "field.label.terms_of_service": "ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ",
        "field.label.new_to_the_platform": "ਪਲੇਟਫਾਰਮ ਲਈ ਨਵੇਂ ਹੋ?",
        "field.label.sign_up": "ਨਵਾਂ ਉਪਭੋਗਤਾ ਰਜਿਸਟਰ ਕਰੋ",
        "field.label.account_url": "ਖਾਤਾ URL",
        "field.label.check_app_status": "ਐਪ ਸਟੇਟਸ ਦੀ ਜਾਂਚ ਕਰੋ..",
        "field.label.new_user_registration": "ਨਵਾਂ ਉਪਭੋਗਤਾ ਰਜਿਸਟ੍ਰੇਸ਼ਨ",
        "field.label.click_hare_for_new_user_registration": "ਨਵੀਂ ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਲਈ ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ",
        "field.label.install_lite_app": "ਲਾਈਟ ਐਪ ਸਥਾਪਿਤ ਕਰੋ",
        "field.label.full_name": "ਪੂਰਾ ਨਾਂਮ",
        "field.label.mobilenumber": "ਮੋਬਾਇਲ ਨੰਬਰ",
        "field.label.accounturl": "ਖਾਤਾ URL",
        "button.label.next": "ਅਗਲਾ",
        "field.label.email_address": "ਈਮੇਲ ਪਤਾ",
        "field.label.reset_password": "ਪਾਸਵਰਡ ਰੀਸੈਟ ਕਰੋ",
        "button.generate_otp": "OTP ਜਨਰੇਟ ਕਰੋ",
        "field.label.select": "ਚੁਣੋ",
        "field.hint.old_password": "ਪੁਰਾਣਾ ਪਾਸਵਰਡ ਦਰਜ ਕਰੋ",
        "button.cancel": "ਰੱਦ ਕਰੋ",
        "button.update": "ਅੱਪਡੇਟ ਕਰੋ",
        "field.label.mobile_number": "ਮੋਬਾਇਲ ਨੰਬਰ",
        "field.label.new_password": "ਨਵਾਂ ਪਾਸਵਰਡ",
        "field.label.old_password": "ਪੁਰਾਣਾ ਪਾਸਵਰਡ",
        "field.hint.new_password": "ਨਵਾਂ ਪਾਸਵਰਡ",
        "field.label.confirm_new_password": "ਨਵੇਂ ਪਾਸਵਰਡ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
        "field.hint.confirm_new_password": "ਨਵੇਂ ਪਾਸਵਰਡ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
        "field.label.confirm_password": "ਪਾਸਵਰਡ ਪੱਕਾ ਕਰੋ",
        "field.label.Enter_otp": "ਰਜਿਸਟਰਡ ਮੋਬਾਈਲ ਨੰਬਰ/ਈਮੇਲ 'ਤੇ ਭੇਜਿਆ ਗਿਆ 6 ਅੰਕਾਂ ਦਾ ਵਨ ਟਾਈਮ ਪਾਸਵਰਡ (OTP) ਦਰਜ ਕਰੋ।",
        "field.label.enter_otp": "ਸੰਪਰਕ ਵੇਰਵਿਆਂ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਲਈ ਅਸੀਂ ਤੁਹਾਨੂੰ ਤੁਹਾਡੇ ਮੋਬਾਈਲ 'ਤੇ 6 ਅੰਕਾਂ ਦਾ ਪੁਸ਼ਟੀਕਰਨ ਕੋਡ ਭੇਜਿਆ ਹੈ।",
        "field.label.Enter_OTP": "ਰਜਿਸਟਰਡ ਮੋਬਾਈਲ ਨੰਬਰ 'ਤੇ ਭੇਜਿਆ ਗਿਆ 6 ਅੰਕਾਂ ਦਾ ਵਨ ਟਾਈਮ ਪਾਸਵਰਡ (OTP) ਦਰਜ ਕਰੋ।",
        "field.label.resend_code": "ਕੋਡ ਦੁਬਾਰਾ ਭੇਜੋ",
        "field.label.resend_OTP": "OTP ਦੁਬਾਰਾ ਭੇਜੋ",
        "field.label.invalid_otp": "ਅਵੈਧ OTP",
        "field.label.invalid_user": "ਅਵੈਧ ਉਪਭੋਗਤਾ",
        "field.label.seconds": "ਸਕਿੰਟ",
        "field.label.UHID": "UHID",
        "field.label.resend_OTP_in_timer_sec": "ਵਿੱਚ OTP ਦੁਬਾਰਾ ਭੇਜੋ",
        "field.label.mobile_number_digits.": "ਮੋਬਾਈਲ ਨੰਬਰ 10 ਅੰਕਾਂ ਤੋਂ ਘੱਟ ਨਹੀਂ ਹੋ ਸਕਦਾ।",
        "field.label.alphabet_cannot_be_accepted": "ਵਰਣਮਾਲਾ ਨੂੰ ਸਵੀਕਾਰ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਦਾ",
        "field.label.login_cannot_be_2": "ਲੌਗਇਨ ਆਈਡੀ 2 ਅੱਖਰਾਂ ਤੋਂ ਘੱਟ ਨਹੀਂ ਹੋ ਸਕਦੀ।",
        "field.label.account_Url_required": "ਖਾਤਾ URL ਘੱਟੋ-ਘੱਟ 2 ਅੱਖਰਾਂ ਦੀ ਲੋੜ ਹੈ।",
        "field.label.account_Url_not_exceed": "ਖਾਤਾ Url 255 ਅੱਖਰਾਂ ਤੋਂ ਵੱਧ ਨਹੀਂ ਹੋ ਸਕਦਾ।",
        "field.label.only_alphabet_hyphen_dot_numbers": "ਸਿਰਫ਼ ਵਰਣਮਾਲਾ, ਹਾਈਫ਼ਨ, ਬਿੰਦੀ ਅਤੇ ਸੰਖਿਆਵਾਂ ਦੀ ਇਜਾਜ਼ਤ ਹੈ।",
        "field.label.password_cannot_be_6": "ਪਾਸਵਰਡ 6 ਅੱਖਰਾਂ ਤੋਂ ਘੱਟ ਨਹੀਂ ਹੋ ਸਕਦਾ।",
        "field.label.confirm_password_required": "ਪੁਸ਼ਟੀ ਪਾਸਵਰਡ ਲੋੜੀਂਦਾ ਹੈ",
        "field.label.passwords_match": "ਕਿਰਪਾ ਕਰਕੇ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਹਾਡੇ ਪਾਸਵਰਡ ਮੇਲ ਖਾਂਦੇ ਹਨ",
        "field.label.type_the_characters": "ਉੱਪਰ ਦਿੱਤੇ ਅੱਖਰ ਟਾਈਪ ਕਰੋ:",
        "field.label.captcha_is_required": "ਕੈਪਚਾ ਲੋੜੀਂਦਾ ਹੈ",
        "field.label.required.password": "ਪਾਸਵਰਡ ਦੀ ਲੋੜ ਹੈ",
        "button.change_password": "ਪਾਸਵਰਡ ਬਦਲੋ",
        "field.label.please_turn_on_notification": "ਬਿਹਤਰ ਅਨੁਭਵ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਸੂਚਨਾ ਚਾਲੂ ਕਰੋ",
        "dam": "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਪ੍ਰਸ਼ਾਸਕ ਨਾਲ ਸੰਪਰਕ ਕਰੋ ਅਤੇ ਇਸ ਡੀਵਾਈਸ ਨੂੰ ਮਨਜ਼ੂਰੀ ਦਿਵਾਓ।",
        "button.manage_user_pin": "ਪਿੰਨ ਬਣਾਓ",
        "button.update_landing_url": "ਲੈਂਡਿੰਗ ਯੂਆਰਐਲ ਨੂੰ ਅੱਪਡੇਟ ਕਰੋ",
        "button.support": "ਸਪੋਰਟ",
        "pagename.list.setDefaultFacility": "ਡਿਫਾਲਟ ਸਹੂਲਤ ਸੈੱਟ ਕਰੋ",
        "button.check_my_internet_speed": "ਮੇਰੀ ਇੰਟਰਨੈੱਟ ਸਪੀਡ ਦੀ ਜਾਂਚ ਕਰੋ",
        "button.check_screen_shortcuts": "ਸ਼ਾਰਟਕੱਟ ਕੁੰਜੀਆਂ",
        "button.install_app": "ਐਪ ਸਥਾਪਿਤ ਕਰੋ",
        "button.logout": "ਲਾੱਗ ਆਊਟ, ਬਾਹਰ ਆਉਣਾ",
        "field.hint.search_menu": "ਖੋਜ ਮੀਨੂ",
        "button.change_login_id": "ਲੌਗਇਨ-ਆਈਡੀ ਬਦਲੋ",
        "field.label.search_role": "ਖੋਜ ਭੂਮਿਕਾ",
        "field.label.quick_otp": "ਰਜਿਸਟਰਡ ਈਮੇਲ 'ਤੇ ਭੇਜਿਆ ਗਿਆ 6 ਅੰਕਾਂ ਦਾ ਵਨ ਟਾਈਮ ਪਾਸਵਰਡ (OTP) ਦਰਜ ਕਰੋ।",
        "field.label.quick_download_verification_code": "ਡਾਊਨਲੋਡ ਜਾਰੀ ਰੱਖਣ ਲਈ ਪੁਸ਼ਟੀਕਰਨ ਕੋਡ ਦਾਖਲ ਕਰੋ...",
        "nto": "ਨੈੱਟਵਰਕ ਟਾਈਮਆਊਟ, ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਇੰਟਰਨੈੱਟ ਕਨੈਕਸ਼ਨ ਦੀ ਜਾਂਚ ਕਰੋ।",
        "cffe": "CSV ਨੂੰ ਫਾਰਮੈਟ ਕਰਨ ਦੌਰਾਨ ਗੜਬੜ",
        "idnf": "ਡਾਊਨਲੋਡ ਨਹੀਂ ਮਿਲਿਆ",
        "otpsuc": "ਤੁਹਾਡੀ ਰਜਿਸਟਰਡ ਈਮੇਲ 'ਤੇ OTP ਸਫਲਤਾਪੂਰਵਕ ਭੇਜਿਆ ਗਿਆ।",
        "field.label.enter_otp_normal": "OTP ਦਾਖਲ ਕਰੋ"
    },
    ta: {
        "field.label.login_id": "உள்நுழைவு ஐடி",
        "field.label.password": "கடவுச்சொல்",
        "button.label.login": "உள்நுழைய",
        "field.label.sign_in": "உள்நுழைய",
        "field.label.forgot_password": "கடவுச்சொல்லை மறந்துவிட்டீர்களா",
        "field.label.patient_login_with_mobile": "OTP மூலம் உள்நுழையவும்",
        "field.label.terms_of_service": "சேவை விதிமுறைகள்",
        "field.label.new_to_the_platform": "மேடையில் புதியதா?",
        "field.label.sign_up": "புதிய பயனரை பதிவு செய்யவும்",
        "field.label.account_url": "கணக்கு URL",
        "field.label.check_app_status": "Appstatus ஐ சரிபார்க்கவும்..",
        "field.label.new_user_registration": "புதிய பயனர் பதிவு",
        "field.label.click_hare_for_new_user_registration": "புதிய பதிவுக்கு இங்கே கிளிக் செய்யவும்",
        "field.label.install_lite_app": "லைட் பயன்பாட்டை நிறுவவும்",
        "field.label.full_name": "முழு பெயர்",
        "field.label.mobilenumber": "கைபேசி எண்",
        "field.label.accounturl": "கணக்கு URL",
        "button.label.next": "அடுத்தது",
        "field.label.email_address": "மின்னஞ்சல் முகவரி",
        "field.label.reset_password": "கடவுச்சொல்லை மீட்டமைக்க",
        "button.generate_otp": "OTP ஐ உருவாக்கவும்",
        "field.label.select": "தேர்ந்தெடு",
        "field.hint.old_password": "பழைய கடவுச்சொல்லை உள்ளிடவும்",
        "button.cancel": "ரத்து செய்",
        "button.update": "புதுப்பிக்கவும்",
        "field.label.mobile_number": "கைபேசி எண்",
        "field.label.new_password": "புதிய கடவுச்சொல்",
        "field.label.old_password": "பழைய கடவுச்சொல்",
        "field.hint.new_password": "புதிய கடவுச்சொல்",
        "field.label.confirm_new_password": "புதிய கடவு சொல்லை உறுதி செய்",
        "field.hint.confirm_new_password": "புதிய கடவு சொல்லை உறுதி செய்",
        "field.label.confirm_password": "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
        "field.label.Enter_otp": "பதிவுசெய்யப்பட்ட மொபைல் எண்/மின்னஞ்சலில் அனுப்பப்பட்ட 6 இலக்க ஒருமுறை கடவுச்சொல்லை (OTP) உள்ளிடவும்.",
        "field.label.enter_otp": "தொடர்பு விவரங்களைச் சரிபார்க்க உங்கள் மொபைலில் 6 இலக்க சரிபார்ப்புக் குறியீட்டை அனுப்பியுள்ளோம்.",
        "field.label.Enter_OTP": "பதிவுசெய்யப்பட்ட மொபைல் எண்ணில் அனுப்பப்பட்ட 6 இலக்க ஒருமுறை கடவுச்சொல்லை (OTP) உள்ளிடவும்.",
        "field.label.resend_code": "குறியீட்டை மீண்டும் அனுப்பு",
        "field.label.resend_OTP": "OTP ஐ மீண்டும் அனுப்பவும்",
        "field.label.invalid_otp": "தவறான OTP",
        "field.label.invalid_user": "தவறான பயனர்",
        "field.label.seconds": "நொடி",
        "field.label.UHID": "UHID",
        "field.label.resend_OTP_in_timer_sec": "OTP ஐ மீண்டும் அனுப்பவும்",
        "field.label.mobile_number_digits.": "மொபைல் எண் 10 இலக்கங்களுக்கு குறைவாக இருக்கக்கூடாது.",
        "field.label.alphabet_cannot_be_accepted": "எழுத்துக்களை ஏற்க முடியாது",
        "field.label.login_cannot_be_2": "உள்நுழைவு ஐடி 2 எழுத்துகளுக்குக் குறைவாக இருக்கக்கூடாது.",
        "field.label.account_Url_required": "கணக்கு Urlக்கு குறைந்தது 2 எழுத்துகள் தேவை.",
        "field.label.account_Url_not_exceed": "கணக்கு Url 255 எழுத்துகளுக்கு மேல் இருக்கக்கூடாது.",
        "field.label.only_alphabet_hyphen_dot_numbers": "எழுத்துக்கள், ஹைபன், புள்ளி மற்றும் எண்கள் மட்டுமே அனுமதிக்கப்படும்.",
        "field.label.password_cannot_be_6": "கடவுச்சொல் 6 எழுத்துகளுக்கு குறைவாக இருக்கக்கூடாது.",
        "field.label.confirm_password_required": "கடவுச்சொல்லை உறுதிப்படுத்த வேண்டும்",
        "field.label.passwords_match": "உங்கள் கடவுச்சொற்கள் பொருந்துவதை உறுதிசெய்யவும்",
        "field.label.type_the_characters": "மேலே உள்ள எழுத்துக்களை உள்ளிடவும்:",
        "field.label.captcha_is_required": "கேப்ட்சா தேவை",
        "field.label.required.password": "கடவுச்சொல் தேவை",
        "button.change_password": "கடவுச்சொல்லை மாற்று",
        "field.label.please_turn_on_notification": "சிறந்த அனுபவத்திற்கு, அறிவிப்பை இயக்கவும்",
        "dam": "உங்கள் நிர்வாகியைத் தொடர்புகொண்டு, இந்தச் சாதனத்தை அங்கீகரிக்கவும்.",
        "button.manage_user_pin": "பின்னை உருவாக்கவும்",
        "button.update_landing_url": "லேண்டிங் URL ஐப் புதுப்பிக்கவும்",
        "button.support": "ஆதரவு",
        "pagename.list.setDefaultFacility": "இயல்புநிலை வசதியை அமைக்கவும்",
        "button.check_my_internet_speed": "எனது இணைய வேகத்தை சரிபார்க்கவும்",
        "button.check_screen_shortcuts": "குறுக்குவழி விசைகள்",
        "button.install_app": "பயன்பாட்டை நிறுவவும்",
        "button.logout": "வெளியேறு",
        "field.hint.search_menu": "தேடல் மெனு",
        "button.change_login_id": "உள்நுழைவு-ஐடியை மாற்றவும்",
        "field.label.search_role": "தேடல் பங்கு",
        "field.label.quick_otp": "பதிவு செய்யப்பட்ட மின்னஞ்சலில் அனுப்பப்பட்ட 6 இலக்க ஒருமுறை கடவுச்சொல்லை (OTP) உள்ளிடவும்.",
        "field.label.quick_download_verification_code": "பதிவிறக்கத்தைத் தொடர, சரிபார்ப்புக் குறியீட்டை உள்ளிடவும்...",
        "nto": "நெட்வொர்க் நேரம் முடிந்தது, உங்கள் இணைய இணைப்பைச் சரிபார்க்கவும்.",
        "cffe": "CSVயை வடிவமைப்பதில் பிழை",
        "idnf": "பதிவிறக்கம் கிடைக்கவில்லை",
        "otpsuc": "உங்கள் பதிவு செய்யப்பட்ட மின்னஞ்சலுக்கு OTP வெற்றிகரமாக அனுப்பப்பட்டது.",
        "field.label.enter_otp_normal": "OTP ஐ உள்ளிடவும்"
    },
    te: {
        "field.label.login_id": "లాగిన్ ID",
        "field.label.password": "పాస్వర్డ్",
        "button.label.login": "ప్రవేశించండి",
        "field.label.sign_in": "ప్రవేశించండి",
        "field.label.forgot_password": "పాస్‌వర్డ్ మర్చిపోయాను",
        "field.label.patient_login_with_mobile": "OTPతో లాగిన్ చేయండి",
        "field.label.terms_of_service": "సేవా నిబంధనలు",
        "field.label.new_to_the_platform": "ప్లాట్‌ఫారమ్‌కి కొత్తవా?",
        "field.label.sign_up": "కొత్త వినియోగదారుని నమోదు చేయండి",
        "field.label.account_url": "ఖాతా Url",
        "field.label.check_app_status": "యాప్‌స్టేటస్‌ని తనిఖీ చేయండి..",
        "field.label.new_user_registration": "కొత్త వినియోగదారు నమోదు",
        "field.label.click_hare_for_new_user_registration": "కొత్త రిజిస్ట్రేషన్ కోసం ఇక్కడ క్లిక్ చేయండి",
        "field.label.install_lite_app": "లైట్ యాప్‌ను ఇన్‌స్టాల్ చేయండి",
        "field.label.full_name": "పూర్తి పేరు",
        "field.label.mobilenumber": "మొబైల్ నంబర్",
        "field.label.accounturl": "ఖాతా Url",
        "button.label.next": "తరువాత",
        "field.label.email_address": "ఇమెయిల్ చిరునామా",
        "field.label.reset_password": "రహస్యపదాన్ని మార్చుకోండి",
        "button.generate_otp": "OTPని రూపొందించండి",
        "field.label.select": "ఎంచుకోండి",
        "field.hint.old_password": "పాత పాస్‌వర్డ్‌ని నమోదు చేయండి",
        "button.cancel": "రద్దు చేయండి",
        "button.update": "నవీకరించు",
        "field.label.mobile_number": "మొబైల్ నంబర్",
        "field.label.new_password": "కొత్త పాస్వర్డ్",
        "field.label.old_password": "పాత పాస్‌వర్డ్",
        "field.hint.new_password": "కొత్త పాస్వర్డ్",
        "field.label.confirm_new_password": "కొత్త పాస్‌వర్డ్‌ని నిర్ధారించండి",
        "field.hint.confirm_new_password": "కొత్త పాస్‌వర్డ్‌ని నిర్ధారించండి",
        "field.label.confirm_password": "పాస్‌వర్డ్‌ని నిర్ధారించండి",
        "field.label.Enter_otp": "రిజిస్టర్డ్ మొబైల్ నంబర్/ఇమెయిల్‌లో పంపబడిన 6 అంకెల వన్ టైమ్ పాస్‌వర్డ్ (OTP)ని నమోదు చేయండి.",
        "field.label.enter_otp": "సంప్రదింపు వివరాలను ధృవీకరించడానికి మేము మీ మొబైల్‌లో 6 అంకెల ధృవీకరణ కోడ్‌ను మీకు పంపాము.",
        "field.label.Enter_OTP": "రిజిస్టర్డ్ మొబైల్ నంబర్‌లో పంపబడిన 6 అంకెల వన్ టైమ్ పాస్‌వర్డ్ (OTP)ని నమోదు చేయండి.",
        "field.label.resend_code": "మళ్ళీ పంపు కోడ్",
        "field.label.resend_OTP": "OTP ను మళ్ళీ పంపు",
        "field.label.invalid_otp": "చెల్లని OTP",
        "field.label.invalid_user": "చెల్లని వినియోగదారు",
        "field.label.seconds": "సెక",
        "field.label.UHID": "UHID",
        "field.label.resend_OTP_in_timer_sec": "OTPని మళ్లీ పంపండి",
        "field.label.mobile_number_digits.": "మొబైల్ నంబర్ 10 అంకెల కంటే తక్కువ ఉండకూడదు.",
        "field.label.alphabet_cannot_be_accepted": "వర్ణమాల అంగీకరించబడదు",
        "field.label.login_cannot_be_2": "లాగిన్ ఐడి 2 అక్షరాల కంటే తక్కువ ఉండకూడదు.",
        "field.label.account_Url_required": "ఖాతా Urlకి కనీసం 2 అక్షరాలు అవసరం.",
        "field.label.account_Url_not_exceed": "ఖాతా Url 255 అక్షరాలను మించకూడదు.",
        "field.label.only_alphabet_hyphen_dot_numbers": "అక్షరం, హైఫన్, చుక్క మరియు సంఖ్యలు మాత్రమే అనుమతించబడతాయి.",
        "field.label.password_cannot_be_6": "పాస్‌వర్డ్ 6 అక్షరాల కంటే తక్కువ ఉండకూడదు.",
        "field.label.confirm_password_required": "పాస్‌వర్డ్‌ని నిర్ధారించడం అవసరం",
        "field.label.passwords_match": "దయచేసి మీ పాస్‌వర్డ్‌లు సరిపోలినట్లు నిర్ధారించుకోండి",
        "field.label.type_the_characters": "పైన ఉన్న అక్షరాలను టైప్ చేయండి:",
        "field.label.captcha_is_required": "Captcha అవసరం",
        "field.label.required.password": "పాస్‌వర్డ్ అవసరం",
        "button.change_password": "పాస్‌వర్డ్ మార్చండి",
        "field.label.please_turn_on_notification": "మెరుగైన అనుభవం కోసం దయచేసి నోటిఫికేషన్‌ని ఆన్ చేయండి",
        "dam": "దయచేసి మీ నిర్వాహకుడిని సంప్రదించండి మరియు ఈ పరికరాన్ని ఆమోదించండి.",
        "button.manage_user_pin": "పిన్‌ని రూపొందించండి",
        "button.update_landing_url": "ల్యాండింగ్ Urlని నవీకరించండి",
        "button.support": "మద్దతు",
        "pagename.list.setDefaultFacility": "డిఫాల్ట్ సౌకర్యాన్ని సెట్ చేయండి",
        "button.check_my_internet_speed": "నా ఇంటర్నెట్ వేగాన్ని తనిఖీ చేయండి",
        "button.check_screen_shortcuts": "సత్వరమార్గం కీలు",
        "button.install_app": "ఆప్ ఇంస్టాల్ చేసుకోండి",
        "button.logout": "లాగ్అవుట్",
        "field.hint.search_menu": "శోధన మెను",
        "button.change_login_id": "లాగిన్-ఐడిని మార్చండి",
        "field.label.search_role": "శోధన పాత్ర",
        "field.label.quick_otp": "రిజిస్టర్డ్ ఇమెయిల్‌లో పంపబడిన 6 అంకెల వన్ టైమ్ పాస్‌వర్డ్ (OTP)ని నమోదు చేయండి.",
        "field.label.quick_download_verification_code": "డౌన్‌లోడ్ కొనసాగించడానికి ధృవీకరణ కోడ్‌ని నమోదు చేయండి...",
        "nto": "నెట్‌వర్క్ గడువు ముగిసింది, దయచేసి మీ ఇంటర్నెట్ కనెక్షన్‌ని తనిఖీ చేయండి.",
        "cffe": "CSVని ఫార్మాట్ చేస్తున్నప్పుడు లోపం",
        "idnf": "డౌన్‌లోడ్ కనుగొనబడలేదు",
        "otpsuc": "మీ నమోదిత ఇమెయిల్‌లో OTP విజయవంతంగా పంపబడింది.",
        "field.label.enter_otp_normal": "OTPని నమోదు చేయండి"
    },
    bn: {
        "field.label.login_id": "লগইন আইডি",
        "field.label.password": "পাসওয়ার্ড",
        "button.label.login": "প্রবেশ করুন",
        "field.label.sign_in": "প্রবেশ করুন",
        "field.label.forgot_password": "পাসওয়ার্ড ভুলে গেছেন",
        "field.label.patient_login_with_mobile": "OTP দিয়ে লগইন করুন",
        "field.label.terms_of_service": "সেবা পাবার শর্ত",
        "field.label.new_to_the_platform": "প্ল্যাটফর্মে নতুন?",
        "field.label.sign_up": "নতুন ব্যবহারকারী নিবন্ধন করুন",
        "field.label.account_url": "অ্যাকাউন্ট ইউআরএল",
        "field.label.check_app_status": "অ্যাপ স্ট্যাটাস চেক করুন..",
        "field.label.new_user_registration": "নতুন ব্যবহারকারীর জন্য নিবন্ধন",
        "field.label.click_hare_for_new_user_registration": "নতুন নিবন্ধনের জন্য এখানে ক্লিক করুন",
        "field.label.install_lite_app": "লাইট অ্যাপ ইনস্টল করুন",
        "field.label.full_name": "পুরো নাম",
        "field.label.mobilenumber": "মোবাইল নম্বর",
        "field.label.accounturl": "অ্যাকাউন্ট ইউআরএল",
        "button.label.next": "পরবর্তী",
        "field.label.email_address": "ইমেইল ঠিকানা",
        "field.label.reset_password": "পাসওয়ার্ড রিসেট করুন",
        "button.generate_otp": "OTP জেনারেট করুন",
        "field.label.select": "নির্বাচন করুন",
        "field.hint.old_password": "পুরানো পাসওয়ার্ড লিখুন",
        "button.cancel": "বাতিল করুন",
        "button.update": "হালনাগাদ",
        "field.label.mobile_number": "মোবাইল নম্বর",
        "field.label.new_password": "নতুন পাসওয়ার্ড",
        "field.label.old_password": "পুরানো পাসওয়ার্ড",
        "field.hint.new_password": "নতুন পাসওয়ার্ড",
        "field.label.confirm_new_password": "নিশ্চিত কর নতুন গোপননম্বর",
        "field.hint.confirm_new_password": "নিশ্চিত কর নতুন গোপননম্বর",
        "field.label.confirm_password": "পাসওয়ার্ড নিশ্চিত করুন",
        "field.label.Enter_otp": "নিবন্ধিত মোবাইল নম্বর/ইমেলে পাঠানো 6 সংখ্যার ওয়ান টাইম পাসওয়ার্ড (OTP) লিখুন।",
        "field.label.enter_otp": "যোগাযোগের বিবরণ যাচাই করার জন্য আমরা আপনার মোবাইলে 6 সংখ্যার যাচাইকরণ কোড পাঠিয়েছি।",
        "field.label.Enter_OTP": "নিবন্ধিত মোবাইল নম্বরে পাঠানো 6 সংখ্যার ওয়ান টাইম পাসওয়ার্ড (OTP) লিখুন।",
        "field.label.resend_code": "পুনরায় পাঠানো কোড",
        "field.label.resend_OTP": "OTP আবার পাঠান",
        "field.label.invalid_otp": "অবৈধ OTP",
        "field.label.invalid_user": "অবৈধ ব্যবহারকারী",
        "field.label.seconds": "সেকেন্ড",
        "field.label.UHID": "ইউএইচআইডি",
        "field.label.resend_OTP_in_timer_sec": "OTP আবার পাঠান",
        "field.label.mobile_number_digits.": "মোবাইল নম্বর 10 সংখ্যার কম হতে পারে না।",
        "field.label.alphabet_cannot_be_accepted": "বর্ণমালা গ্রহণ করা যাবে না",
        "field.label.login_cannot_be_2": "লগইন আইডি 2 অক্ষরের কম হতে পারে না।",
        "field.label.account_Url_required": "অ্যাকাউন্ট Url কমপক্ষে 2 অক্ষর প্রয়োজন।",
        "field.label.account_Url_not_exceed": "অ্যাকাউন্ট Url 255 অক্ষরের বেশি হতে পারে না।",
        "field.label.only_alphabet_hyphen_dot_numbers": "শুধুমাত্র বর্ণমালা, হাইফেন, ডট এবং সংখ্যা অনুমোদিত।",
        "field.label.password_cannot_be_6": "পাসওয়ার্ড 6 অক্ষরের কম হতে পারে না।",
        "field.label.confirm_password_required": "পাসওয়ার্ড নিশ্চিত করুন প্রয়োজন বোধ করা হয়",
        "field.label.passwords_match": "আপনার পাসওয়ার্ড মেলে নিশ্চিত করুন",
        "field.label.type_the_characters": "উপরের অক্ষর টাইপ করুন:",
        "field.label.captcha_is_required": "ক্যাপচা প্রয়োজন",
        "field.label.required.password": "পাসওয়ার্ড প্রয়োজন",
        "button.change_password": "পাসওয়ার্ড পরিবর্তন করুন",
        "field.label.please_turn_on_notification": "আরও ভালো অভিজ্ঞতার জন্য অনুগ্রহ করে বিজ্ঞপ্তি চালু করুন",
        "dam": "অনুগ্রহ করে আপনার প্রশাসকের সাথে যোগাযোগ করুন এবং এই ডিভাইসটি অনুমোদিত করুন৷",
        "button.manage_user_pin": "পিন তৈরি করুন",
        "button.update_landing_url": "ল্যান্ডিং ইউআরএল আপডেট করুন",
        "button.support": "সমর্থন",
        "pagename.list.setDefaultFacility": "ডিফল্ট সুবিধা সেট করুন",
        "button.check_my_internet_speed": "আমার ইন্টারনেট গতি পরীক্ষা করুন",
        "button.check_screen_shortcuts": "শর্টকাট কী",
        "button.install_app": "অ্যাপ্লিকেশন ইনস্টল",
        "button.logout": "প্রস্থান",
        "field.hint.search_menu": "অনুসন্ধান মেনু",
        "button.change_login_id": "লগইন-আইডি পরিবর্তন করুন",
        "field.label.search_role": "অনুসন্ধান ভূমিকা",
        "field.label.quick_otp": "নিবন্ধিত ইমেলে পাঠানো 6 সংখ্যার ওয়ান টাইম পাসওয়ার্ড (OTP) লিখুন।",
        "field.label.quick_download_verification_code": "ডাউনলোড চালিয়ে যেতে যাচাইকরণ কোড লিখুন...",
        "nto": "নেটওয়ার্ক টাইম আউট, আপনার ইন্টারনেট সংযোগ পরীক্ষা করুন.",
        "cffe": "CSV ফর্ম্যাট করার সময় ত্রুটি৷",
        "idnf": "ডাউনলোড পাওয়া যায়নি",
        "otpsuc": "আপনার নিবন্ধিত ইমেলে OTP সফলভাবে পাঠানো হয়েছে।",
        "field.label.enter_otp_normal": "OTP লিখুন"
    },
    mr: {
        "field.label.login_id": "लॉगिन आईडी",
        "field.label.password": "पासवर्ड",
        "button.label.login": "लॉगिन करा",
        "field.label.sign_in": "लॉगिन करा",
        "field.label.forgot_password": "पासवर्ड विसरलात",
        "field.label.patient_login_with_mobile": "OTP ने लॉगिन करा",
        "field.label.terms_of_service": "सेवा अटी",
        "field.label.new_to_the_platform": "प्लॅटफॉर्मवर नवीन आहात?",
        "field.label.sign_up": "नवीन वापरकर्ता नोंदणी करा",
        "field.label.account_url": "खाते Url",
        "field.label.check_app_status": "अॅप स्टेटस तपासा..",
        "field.label.new_user_registration": "नवीन वापरकर्ता नोंदणी",
        "field.label.click_hare_for_new_user_registration": "नवीन नोंदणीसाठी येथे क्लिक करा",
        "field.label.install_lite_app": "लाइट अॅप स्थापित करा",
        "field.label.full_name": "पूर्ण नाव",
        "field.label.mobilenumber": "मोबाईल नंबर",
        "field.label.accounturl": "खाते Url",
        "button.label.next": "पुढे",
        "field.label.email_address": "ईमेल पत्ता",
        "field.label.reset_password": "पासवर्ड रीसेट करा",
        "button.generate_otp": "OTP जनरेट करा",
        "field.label.select": "निवडा",
        "field.hint.old_password": "जुना पासवर्ड टाका",
        "button.cancel": "रद्द करा",
        "button.update": "अपडेट करा",
        "field.label.mobile_number": "मोबाईल नंबर",
        "field.label.new_password": "नवीन पासवर्ड",
        "field.label.old_password": "जुना पासवर्ड",
        "field.hint.new_password": "नवीन पासवर्ड",
        "field.label.confirm_new_password": "नवीन परवलीच्या शब्दाची खात्री करा",
        "field.hint.confirm_new_password": "नवीन परवलीच्या शब्दाची खात्री करा",
        "field.label.confirm_password": "पासवर्डची पुष्टी करा",
        "field.label.Enter_otp": "नोंदणीकृत मोबाईल नंबर/ईमेलवर पाठवलेला 6 अंकी वन टाइम पासवर्ड (OTP) एंटर करा.",
        "field.label.enter_otp": "संपर्क तपशील सत्यापित करण्यासाठी आम्ही तुम्हाला तुमच्या मोबाईलवर 6 अंकी सत्यापन कोड पाठवला आहे.",
        "field.label.Enter_OTP": "नोंदणीकृत मोबाईल नंबरवर पाठवलेला 6 अंकी वन टाइम पासवर्ड (OTP) एंटर करा.",
        "field.label.resend_code": "कोड पुन्हा पाठवा",
        "field.label.resend_OTP": "OTP पुन्हा पाठवा",
        "field.label.invalid_otp": "अवैध OTP",
        "field.label.invalid_user": "अवैध वापरकर्ता",
        "field.label.seconds": "सेकंद",
        "field.label.UHID": "UHID",
        "field.label.resend_OTP_in_timer_sec": "मध्ये OTP पुन्हा पाठवा",
        "field.label.mobile_number_digits.": "मोबाईल नंबर 10 अंकांपेक्षा कमी असू शकत नाही.",
        "field.label.alphabet_cannot_be_accepted": "वर्णमाला स्वीकारली जाऊ शकत नाही",
        "field.label.login_cannot_be_2": "लॉगिन आयडी 2 वर्णांपेक्षा कमी असू शकत नाही.",
        "field.label.account_Url_required": "खाते Url किमान 2 वर्ण आवश्यक आहे.",
        "field.label.account_Url_not_exceed": "खाते Url 255 वर्णांपेक्षा जास्त असू शकत नाही.",
        "field.label.only_alphabet_hyphen_dot_numbers": "फक्त वर्णमाला, हायफन, बिंदू आणि संख्यांना अनुमती आहे.",
        "field.label.password_cannot_be_6": "पासवर्ड 6 वर्णांपेक्षा कमी असू शकत नाही.",
        "field.label.confirm_password_required": "पासवर्ड आवश्यक असल्याची पुष्टी करा",
        "field.label.passwords_match": "कृपया तुमचे पासवर्ड जुळत असल्याची खात्री करा",
        "field.label.type_the_characters": "वरील वर्ण टाइप करा:",
        "field.label.captcha_is_required": "कॅप्चा आवश्यक आहे",
        "field.label.required.password": "पासवर्ड आवश्यक",
        "button.change_password": "पासवर्ड बदला",
        "field.label.please_turn_on_notification": "चांगल्या अनुभवासाठी कृपया सूचना चालू करा",
        "dam": "कृपया तुमच्या प्रशासकाशी संपर्क साधा आणि हे डिव्हाइस मंजूर करा.",
        "button.manage_user_pin": "पिन तयार करा",
        "button.update_landing_url": "लँडिंग Url अद्यतनित करा",
        "button.support": "सपोर्ट",
        "pagename.list.setDefaultFacility": "डीफॉल्ट सुविधा सेट करा",
        "button.check_my_internet_speed": "माझा इंटरनेट स्पीड तपासा",
        "button.check_screen_shortcuts": "शॉर्टकट की",
        "button.install_app": "अॅप इंस्टॉल करा",
        "button.logout": "बाहेर पडणे",
        "field.hint.search_menu": "शोध मेनू",
        "button.change_login_id": "लॉगिन-आयडी बदला",
        "field.label.search_role": "शोध भूमिका",
        "field.label.quick_otp": "नोंदणीकृत ईमेलवर पाठवलेला 6 अंकी वन टाइम पासवर्ड (OTP) एंटर करा.",
        "field.label.quick_download_verification_code": "डाउनलोड सुरू ठेवण्यासाठी सत्यापन कोड प्रविष्ट करा...",
        "nto": "नेटवर्क कालबाह्य, कृपया तुमचे इंटरनेट कनेक्शन तपासा.",
        "cffe": "CSV फॉरमॅट करताना त्रुटी",
        "idnf": "डाउनलोड आढळले नाही",
        "otpsuc": "तुमच्या नोंदणीकृत ईमेलवर OTP यशस्वीरित्या पाठवला.",
        "field.label.enter_otp_normal": "OTP एंटर करा"
    },
    nl: {
        "field.label.login_id": "Inlog ID",
        "field.label.password": "Wachtwoord",
        "button.label.login": "Log in",
        "field.label.sign_in": "Log in",
        "field.label.forgot_password": "Wachtwoord vergeten",
        "field.label.patient_login_with_mobile": "Inloggen met OTP",
        "field.label.terms_of_service": "Servicevoorwaarden",
        "field.label.new_to_the_platform": "Nieuw op het platform?",
        "field.label.sign_up": "Registreer nieuwe gebruiker",
        "field.label.account_url": "Account-URL",
        "field.label.check_app_status": "Controleer appstatus..",
        "field.label.new_user_registration": "Nieuwe gebruiker registratie",
        "field.label.click_hare_for_new_user_registration": "Klik hier voor nieuwe registratie",
        "field.label.install_lite_app": "Installeer de Lite-app",
        "field.label.full_name": "Voor-en achternaam",
        "field.label.mobilenumber": "Mobiel nummer",
        "field.label.accounturl": "Account-URL",
        "button.label.next": "Volgende",
        "field.label.email_address": "E-mailadres",
        "field.label.reset_password": "Wachtwoord opnieuw instellen",
        "button.generate_otp": "Genereer OTP",
        "field.label.select": "Selecteer",
        "field.hint.old_password": "Voer het oude wachtwoord in",
        "button.cancel": "Annuleren",
        "button.update": "Update",
        "field.label.mobile_number": "Mobiel nummer",
        "field.label.new_password": "nieuw paswoord",
        "field.label.old_password": "Oud Wachtwoord",
        "field.hint.new_password": "nieuw paswoord",
        "field.label.confirm_new_password": "Bevestig nieuw wachtwoord",
        "field.hint.confirm_new_password": "Bevestig nieuw wachtwoord",
        "field.label.confirm_password": "bevestig wachtwoord",
        "field.label.Enter_otp": "Voer een 6-cijferig eenmalig wachtwoord (OTP) in, verzonden op geregistreerd mobiel nummer/e-mailadres.",
        "field.label.enter_otp": "We hebben u een 6-cijferige verificatiecode op uw mobiel gestuurd om de contactgegevens te verifiëren.",
        "field.label.Enter_OTP": "Voer een 6-cijferig eenmalig wachtwoord (OTP) in, verzonden naar een geregistreerd mobiel nummer.",
        "field.label.resend_code": "Code nogmaals versturen",
        "field.label.resend_OTP": "OTP opnieuw verzenden",
        "field.label.invalid_otp": "Ongeldige OTP",
        "field.label.invalid_user": "ongeldige gebruiker",
        "field.label.seconds": "sec",
        "field.label.UHID": "UHID",
        "field.label.resend_OTP_in_timer_sec": "OTP opnieuw verzenden",
        "field.label.mobile_number_digits.": "Mobiel nummer mag niet minder dan 10 cijfers bevatten.",
        "field.label.alphabet_cannot_be_accepted": "Alfabet kan niet worden geaccepteerd",
        "field.label.login_cannot_be_2": "De login-ID mag niet minder dan 2 tekens lang zijn.",
        "field.label.account_Url_required": "Account-URL vereist minimaal 2 tekens.",
        "field.label.account_Url_not_exceed": "Account-URL mag niet langer zijn dan 255 tekens.",
        "field.label.only_alphabet_hyphen_dot_numbers": "Alleen alfabetten, koppeltekens, punten en cijfers zijn toegestaan.",
        "field.label.password_cannot_be_6": "Wachtwoord mag niet korter zijn dan 6 tekens.",
        "field.label.confirm_password_required": "Bevestig wachtwoord is vereist",
        "field.label.passwords_match": "Zorg er alstublieft voor dat uw wachtwoorden overeenkomen",
        "field.label.type_the_characters": "Typ de karakters hierboven:",
        "field.label.captcha_is_required": "Captcha is vereist",
        "field.label.required.password": "Wachtwoord benodigd",
        "button.change_password": "Verander wachtwoord",
        "field.label.please_turn_on_notification": "Schakel de melding in voor een betere ervaring",
        "dam": "Neem contact op met uw beheerder en zorg ervoor dat dit apparaat wordt goedgekeurd.",
        "button.manage_user_pin": "Pin genereren",
        "button.update_landing_url": "Landings-URL bijwerken",
        "button.support": "Steun",
        "pagename.list.setDefaultFacility": "Stel standaardfaciliteit in",
        "button.check_my_internet_speed": "Controleer mijn internetsnelheid",
        "button.check_screen_shortcuts": "Sneltoetsen",
        "button.install_app": "Installeer app",
        "button.logout": "Uitloggen",
        "field.hint.search_menu": "Zoekmenu",
        "button.change_login_id": "Wijzig login-ID",
        "field.label.search_role": "Zoekrol",
        "field.label.quick_otp": "Voer een 6-cijferig eenmalig wachtwoord (OTP) in, verzonden via een geregistreerde e-mail.",
        "field.label.quick_download_verification_code": "Voer de verificatiecode in om door te gaan met downloaden...",
        "nto": "Netwerktime-out. Controleer uw internetverbinding.",
        "cffe": "Fout bij het formatteren van de CSV",
        "idnf": "Downloaden niet gevonden",
        "otpsuc": "OTP succesvol verzonden naar uw geregistreerde e-mailadres.",
        "field.label.enter_otp_normal": "Voer OTP in"
    },
    gu: {
        "field.label.login_id": "લૉગિન આઈડી",
        "field.label.password": "પાસવર્ડ",
        "button.label.login": "પ્રવેશ કરો",
        "field.label.sign_in": "પ્રવેશ કરો",
        "field.label.forgot_password": "પાસવર્ડ ભૂલી ગયા છો",
        "field.label.patient_login_with_mobile": "OTP વડે લોગિન કરો",
        "field.label.terms_of_service": "સેવાની શરતો",
        "field.label.new_to_the_platform": "પ્લેટફોર્મ પર નવા છો?",
        "field.label.sign_up": "નવા વપરાશકર્તાની નોંધણી કરો",
        "field.label.account_url": "એકાઉન્ટ Url",
        "field.label.check_app_status": "એપ સ્ટેટસ તપાસો..",
        "field.label.new_user_registration": "નવી વપરાશકર્તા નોંધણી",
        "field.label.click_hare_for_new_user_registration": "નવી નોંધણી માટે અહીં ક્લિક કરો",
        "field.label.install_lite_app": "લાઇટ એપ્લિકેશન ઇન્સ્ટોલ કરો",
        "field.label.full_name": "પૂરું નામ",
        "field.label.mobilenumber": "મોબાઇલ નંબર",
        "field.label.accounturl": "એકાઉન્ટ Url",
        "button.label.next": "આગળ",
        "field.label.email_address": "ઈ - મેઈલ સરનામું",
        "field.label.reset_password": "પાસવર્ડ રીસેટ કરો",
        "button.generate_otp": "OTP જનરેટ કરો",
        "field.label.select": "પસંદ કરો",
        "field.hint.old_password": "જૂનો પાસવર્ડ દાખલ કરો",
        "button.cancel": "રદ કરો",
        "button.update": "અપડેટ કરો",
        "field.label.mobile_number": "મોબાઇલ નંબર",
        "field.label.new_password": "નવો પાસવર્ડ",
        "field.label.old_password": "જુનો પાસવર્ડ",
        "field.hint.new_password": "નવો પાસવર્ડ",
        "field.label.confirm_new_password": "નવાપાસવર્ડની પુષ્ટી કરો",
        "field.hint.confirm_new_password": "નવાપાસવર્ડની પુષ્ટી કરો",
        "field.label.confirm_password": "પાસવર્ડની પુષ્ટિ કરો",
        "field.label.Enter_otp": "રજિસ્ટર્ડ મોબાઈલ નંબર/ઈમેલ પર મોકલેલ 6 અંકનો વન ટાઈમ પાસવર્ડ (OTP) દાખલ કરો.",
        "field.label.enter_otp": "સંપર્ક વિગતો ચકાસવા માટે અમે તમને તમારા મોબાઈલ પર 6 અંકનો વેરિફિકેશન કોડ મોકલ્યો છે.",
        "field.label.Enter_OTP": "રજિસ્ટર્ડ મોબાઈલ નંબર પર મોકલેલ 6 અંકનો વન ટાઈમ પાસવર્ડ (OTP) દાખલ કરો.",
        "field.label.resend_code": "કોડ ફરીથી મોકલો",
        "field.label.resend_OTP": "OTP ફરીથી મોકલો",
        "field.label.invalid_otp": "અમાન્ય OTP",
        "field.label.invalid_user": "અમાન્ય વપરાશકર્તા",
        "field.label.seconds": "સેકન્ડ",
        "field.label.UHID": "UHID",
        "field.label.resend_OTP_in_timer_sec": "માં OTP ફરીથી મોકલો",
        "field.label.mobile_number_digits.": "મોબાઈલ નંબર 10 અંકથી ઓછો ન હોઈ શકે.",
        "field.label.alphabet_cannot_be_accepted": "મૂળાક્ષરો સ્વીકારી શકાતા નથી",
        "field.label.login_cannot_be_2": "લૉગિન આઈડી 2 અક્ષરથી ઓછી ન હોઈ શકે.",
        "field.label.account_Url_required": "એકાઉન્ટ Url ઓછામાં ઓછા 2 અક્ષરોની જરૂર છે.",
        "field.label.account_Url_not_exceed": "એકાઉન્ટ Url 255 અક્ષરોથી વધુ ન હોઈ શકે.",
        "field.label.only_alphabet_hyphen_dot_numbers": "ફક્ત આલ્ફાબેટ, હાઇફન, ડોટ અને નંબરોને મંજૂરી છે.",
        "field.label.password_cannot_be_6": "પાસવર્ડ 6 અક્ષરથી ઓછો ન હોઈ શકે.",
        "field.label.confirm_password_required": "પુષ્ટિ કરો પાસવર્ડ જરૂરી છે",
        "field.label.passwords_match": "કૃપા કરીને ખાતરી કરો કે તમારા પાસવર્ડ્સ મેળ ખાય છે",
        "field.label.type_the_characters": "ઉપરના અક્ષરો લખો:",
        "field.label.captcha_is_required": "કેપ્ચા જરૂરી છે",
        "field.label.required.password": "પાસવર્ડ જરૂરી છે",
        "button.change_password": "પાસવર્ડ બદલો",
        "field.label.please_turn_on_notification": "વધુ સારા અનુભવ માટે કૃપા કરીને સૂચના ચાલુ કરો",
        "dam": "કૃપા કરીને તમારા વ્યવસ્થાપકનો સંપર્ક કરો અને આ ઉપકરણને મંજૂરી આપો.",
        "button.manage_user_pin": "પિન જનરેટ કરો",
        "button.update_landing_url": "લેન્ડિંગ Url અપડેટ કરો",
        "button.support": "આધાર",
        "pagename.list.setDefaultFacility": "ડિફોલ્ટ સુવિધા સેટ કરો",
        "button.check_my_internet_speed": "મારી ઈન્ટરનેટ સ્પીડ તપાસો",
        "button.check_screen_shortcuts": "શોર્ટકટ કી",
        "button.install_app": "એપ ઇન્સ્ટોલ કરો",
        "button.logout": "લૉગ આઉટ",
        "field.hint.search_menu": "શોધ મેનૂ",
        "button.change_login_id": "લોગિન આઈડી બદલો",
        "field.label.search_role": "શોધ ભૂમિકા",
        "field.label.quick_otp": "રજિસ્ટર્ડ ઈમેલ પર મોકલેલ 6 અંકનો વન ટાઈમ પાસવર્ડ (OTP) દાખલ કરો.",
        "field.label.quick_download_verification_code": "ડાઉનલોડ ચાલુ રાખવા માટે ચકાસણી કોડ દાખલ કરો...",
        "nto": "નેટવર્ક સમય સમાપ્ત, કૃપા કરીને તમારું ઇન્ટરનેટ કનેક્શન તપાસો.",
        "cffe": "CSV ફોર્મેટ કરતી વખતે ભૂલ",
        "idnf": "ડાઉનલોડ મળ્યું નથી",
        "otpsuc": "તમારા રજિસ્ટર્ડ ઈમેલ પર OTP સફળતાપૂર્વક મોકલવામાં આવ્યો.",
        "field.label.enter_otp_normal": "OTP દાખલ કરો"
    },
    kn: {
        "field.label.login_id": "ಲಾಗಿನ್ ಐಡಿ",
        "field.label.password": "ಗುಪ್ತಪದ",
        "button.label.login": "ಲಾಗಿನ್ ಮಾಡಿ",
        "field.label.sign_in": "ಲಾಗಿನ್ ಮಾಡಿ",
        "field.label.forgot_password": "ಪಾಸ್ವರ್ಡ್ ಮರೆತಿರಾ",
        "field.label.patient_login_with_mobile": "OTP ಯೊಂದಿಗೆ ಲಾಗಿನ್ ಮಾಡಿ",
        "field.label.terms_of_service": "ಸೇವಾ ನಿಯಮಗಳು",
        "field.label.new_to_the_platform": "ವೇದಿಕೆಗೆ ಹೊಸಬರೇ?",
        "field.label.sign_up": "ಹೊಸ ಬಳಕೆದಾರರನ್ನು ನೋಂದಾಯಿಸಿ",
        "field.label.account_url": "ಖಾತೆ URL",
        "field.label.check_app_status": "ಅಪ್ಲಿಕೇಶನ್ ಸ್ಥಿತಿಯನ್ನು ಪರಿಶೀಲಿಸಿ..",
        "field.label.new_user_registration": "ಹೊಸ ಬಳಕೆದಾರರ ನೋಂದಣಿ",
        "field.label.click_hare_for_new_user_registration": "ಹೊಸ ನೋಂದಣಿಗಾಗಿ ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
        "field.label.install_lite_app": "ಲೈಟ್ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಸ್ಥಾಪಿಸಿ",
        "field.label.full_name": "ಪೂರ್ಣ ಹೆಸರು",
        "field.label.mobilenumber": "ಮೊಬೈಲ್ ನಂಬರ",
        "field.label.accounturl": "ಖಾತೆ URL",
        "button.label.next": "ಮುಂದೆ",
        "field.label.email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
        "field.label.reset_password": "ಪಾಸ್ವರ್ಡ್ ಮರುಹೊಂದಿಸಿ",
        "button.generate_otp": "OTP ರಚಿಸಿ",
        "field.label.select": "ಆಯ್ಕೆ ಮಾಡಿ",
        "field.hint.old_password": "ಹಳೆಯ ಪಾಸ್ವರ್ಡ್ ನಮೂದಿಸಿ",
        "button.cancel": "ರದ್ದುಮಾಡಿ",
        "button.update": "ನವೀಕರಿಸಿ",
        "field.label.mobile_number": "ಮೊಬೈಲ್ ನಂಬರ",
        "field.label.new_password": "ಹೊಸ ಪಾಸ್ವರ್ಡ್",
        "field.label.old_password": "ಹಳೆಯ ಪಾಸ್ವರ್ಡ್",
        "field.hint.new_password": "ಹೊಸ ಪಾಸ್ವರ್ಡ್",
        "field.label.confirm_new_password": "ಹೊಸ ಗುಪ್ತಪದವನ್ನು ಖಚಿತಪಡಿಸಿ",
        "field.hint.confirm_new_password": "ಹೊಸ ಗುಪ್ತಪದವನ್ನು ಖಚಿತಪಡಿಸಿ",
        "field.label.confirm_password": "ಪಾಸ್ವರ್ಡ್ ದೃಢೀಕರಿಸಿ",
        "field.label.Enter_otp": "ನೋಂದಾಯಿತ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ/ಇಮೇಲ್‌ನಲ್ಲಿ ಕಳುಹಿಸಲಾದ 6 ಅಂಕೆಗಳ ಒನ್ ಟೈಮ್ ಪಾಸ್‌ವರ್ಡ್ (OTP) ನಮೂದಿಸಿ.",
        "field.label.enter_otp": "ಸಂಪರ್ಕ ವಿವರಗಳನ್ನು ಪರಿಶೀಲಿಸಲು ನಾವು ನಿಮ್ಮ ಮೊಬೈಲ್‌ನಲ್ಲಿ 6 ಅಂಕಿಗಳ ಪರಿಶೀಲನೆ ಕೋಡ್ ಅನ್ನು ಕಳುಹಿಸಿದ್ದೇವೆ.",
        "field.label.Enter_OTP": "ನೋಂದಾಯಿತ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಗೆ ಕಳುಹಿಸಲಾದ 6 ಅಂಕೆಗಳ ಒನ್ ಟೈಮ್ ಪಾಸ್‌ವರ್ಡ್ (OTP) ನಮೂದಿಸಿ.",
        "field.label.resend_code": "ಕೋಡ್ ಅನ್ನು ಮರುಕಳುಹಿಸಿ",
        "field.label.resend_OTP": "OTP ಅನ್ನು ಮರುಕಳುಹಿಸಿ",
        "field.label.invalid_otp": "ಅಮಾನ್ಯ OTP",
        "field.label.invalid_user": "ಅಮಾನ್ಯ ಬಳಕೆದಾರ",
        "field.label.seconds": "ಸೆಕೆಂಡು",
        "field.label.UHID": "UHID",
        "field.label.resend_OTP_in_timer_sec": "OTP ಅನ್ನು ಮರುಕಳುಹಿಸಿ",
        "field.label.mobile_number_digits.": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯು 10 ಅಂಕಿಗಳಿಗಿಂತ ಕಡಿಮೆ ಇರುವಂತಿಲ್ಲ.",
        "field.label.alphabet_cannot_be_accepted": "ವರ್ಣಮಾಲೆಯನ್ನು ಸ್ವೀಕರಿಸಲಾಗುವುದಿಲ್ಲ",
        "field.label.login_cannot_be_2": "ಲಾಗಿನ್ ಐಡಿ 2 ಅಕ್ಷರಗಳಿಗಿಂತ ಕಡಿಮೆ ಇರುವಂತಿಲ್ಲ.",
        "field.label.account_Url_required": "ಖಾತೆಯ Url ಗೆ ಕನಿಷ್ಠ 2 ಅಕ್ಷರಗಳ ಅಗತ್ಯವಿದೆ.",
        "field.label.account_Url_not_exceed": "ಖಾತೆಯ Url 255 ಅಕ್ಷರಗಳನ್ನು ಮೀರಬಾರದು.",
        "field.label.only_alphabet_hyphen_dot_numbers": "ಆಲ್ಫಾಬೆಟ್, ಹೈಫನ್, ಡಾಟ್ ಮತ್ತು ಸಂಖ್ಯೆಗಳನ್ನು ಮಾತ್ರ ಅನುಮತಿಸಲಾಗಿದೆ.",
        "field.label.password_cannot_be_6": "ಪಾಸ್ವರ್ಡ್ 6 ಅಕ್ಷರಗಳಿಗಿಂತ ಕಡಿಮೆ ಇರುವಂತಿಲ್ಲ.",
        "field.label.confirm_password_required": "ಪಾಸ್ವರ್ಡ್ ದೃಢೀಕರಿಸುವ ಅಗತ್ಯವಿದೆ",
        "field.label.passwords_match": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್‌ಗಳು ಹೊಂದಾಣಿಕೆಯಾಗುವುದನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ",
        "field.label.type_the_characters": "ಮೇಲಿನ ಅಕ್ಷರಗಳನ್ನು ಟೈಪ್ ಮಾಡಿ:",
        "field.label.captcha_is_required": "ಕ್ಯಾಪ್ಚಾ ಅಗತ್ಯವಿದೆ",
        "field.label.required.password": "ಪಾಸ್ವರ್ಡ್ ಅಗತ್ಯವಿದೆ",
        "button.change_password": "ಗುಪ್ತಪದವನ್ನು ಬದಲಿಸಿ",
        "field.label.please_turn_on_notification": "ಉತ್ತಮ ಅನುಭವಕ್ಕಾಗಿ ದಯವಿಟ್ಟು ಅಧಿಸೂಚನೆಯನ್ನು ಆನ್ ಮಾಡಿ",
        "dam": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ನಿರ್ವಾಹಕರನ್ನು ಸಂಪರ್ಕಿಸಿ ಮತ್ತು ಈ ಸಾಧನವನ್ನು ಅನುಮೋದಿಸಿ.",
        "button.manage_user_pin": "ಪಿನ್ ರಚಿಸಿ",
        "button.update_landing_url": "ಲ್ಯಾಂಡಿಂಗ್ URL ಅನ್ನು ನವೀಕರಿಸಿ",
        "button.support": "ಬೆಂಬಲ",
        "pagename.list.setDefaultFacility": "ಡೀಫಾಲ್ಟ್ ಸೌಲಭ್ಯವನ್ನು ಹೊಂದಿಸಿ",
        "button.check_my_internet_speed": "ನನ್ನ ಇಂಟರ್ನೆಟ್ ವೇಗವನ್ನು ಪರಿಶೀಲಿಸಿ",
        "button.check_screen_shortcuts": "ಶಾರ್ಟ್ಕಟ್ ಕೀಗಳು",
        "button.install_app": "ಅಪ್ಲಿಕೇಶನ್ ಇನ್ಸ್ಟಾಲ್ ಮಾಡಿ",
        "button.logout": "ಲಾಗ್ ಔಟ್",
        "field.hint.search_menu": "ಹುಡುಕಾಟ ಮೆನು",
        "button.change_login_id": "ಲಾಗಿನ್-ಐಡಿ ಬದಲಾಯಿಸಿ",
        "field.label.search_role": "ಹುಡುಕಾಟ ಪಾತ್ರ",
        "field.label.quick_otp": "ನೋಂದಾಯಿತ ಇಮೇಲ್‌ನಲ್ಲಿ ಕಳುಹಿಸಲಾದ 6 ಅಂಕೆಗಳ ಒನ್ ಟೈಮ್ ಪಾಸ್‌ವರ್ಡ್ (OTP) ನಮೂದಿಸಿ.",
        "field.label.quick_download_verification_code": "ಡೌನ್‌ಲೋಡ್ ಮುಂದುವರಿಸಲು ಪರಿಶೀಲನೆ ಕೋಡ್ ನಮೂದಿಸಿ...",
        "nto": "ನೆಟ್‌ವರ್ಕ್ ಸಮಯ ಮೀರಿದೆ, ದಯವಿಟ್ಟು ನಿಮ್ಮ ಇಂಟರ್ನೆಟ್ ಸಂಪರ್ಕವನ್ನು ಪರಿಶೀಲಿಸಿ.",
        "cffe": "CSV ಫಾರ್ಮ್ಯಾಟ್ ಮಾಡುವಾಗ ದೋಷ",
        "idnf": "ಡೌನ್‌ಲೋಡ್ ಕಂಡುಬಂದಿಲ್ಲ",
        "otpsuc": "ನಿಮ್ಮ ನೋಂದಾಯಿತ ಇಮೇಲ್‌ನಲ್ಲಿ OTP ಯಶಸ್ವಿಯಾಗಿ ಕಳುಹಿಸಲಾಗಿದೆ.",
        "field.label.enter_otp_normal": "OTP ನಮೂದಿಸಿ"
    },
    ml: {
        "field.label.login_id": "ലോഗിൻ ഐഡി",
        "field.label.password": "Password",
        "button.label.login": "ലോഗിൻ",
        "field.label.sign_in": "ലോഗിൻ",
        "field.label.forgot_password": "പാസ്വേഡ് മറന്നോ",
        "field.label.patient_login_with_mobile": "OTP ഉപയോഗിച്ച് ലോഗിൻ ചെയ്യുക",
        "field.label.terms_of_service": "സേവന നിബന്ധനകൾ",
        "field.label.new_to_the_platform": "പ്ലാറ്റ്‌ഫോമിൽ പുതിയത്?",
        "field.label.sign_up": "പുതിയ ഉപയോക്താവിനെ രജിസ്റ്റർ ചെയ്യുക",
        "field.label.account_url": "അക്കൗണ്ട് യുആർഎൽ",
        "field.label.check_app_status": "ആപ്പ് സ്റ്റാറ്റസ് പരിശോധിക്കുക..",
        "field.label.new_user_registration": "പുതിയ ഉപയോക്തൃ രജിസ്ട്രേഷൻ",
        "field.label.click_hare_for_new_user_registration": "പുതിയ രജിസ്ട്രേഷനായി ഇവിടെ ക്ലിക്ക് ചെയ്യുക",
        "field.label.install_lite_app": "ലൈറ്റ് ആപ്പ് ഇൻസ്റ്റാൾ ചെയ്യുക",
        "field.label.full_name": "പൂർണ്ണമായ പേര്",
        "field.label.mobilenumber": "മൊബൈൽ നമ്പർ",
        "field.label.accounturl": "അക്കൗണ്ട് യുആർഎൽ",
        "button.label.next": "അടുത്തത്",
        "field.label.email_address": "ഇമെയിൽ വിലാസം",
        "field.label.reset_password": "പാസ്‌വേഡ് പുനഃസജ്ജമാക്കുക",
        "button.generate_otp": "OTP സൃഷ്ടിക്കുക",
        "field.label.select": "തിരഞ്ഞെടുക്കുക",
        "field.hint.old_password": "പഴയ പാസ്‌വേഡ് നൽകുക",
        "button.cancel": "റദ്ദാക്കുക",
        "button.update": "അപ്ഡേറ്റ് ചെയ്യുക",
        "field.label.mobile_number": "മൊബൈൽ നമ്പർ",
        "field.label.new_password": "പുതിയ പാസ്വേഡ്",
        "field.label.old_password": "പഴയ പാസ്വേഡ്",
        "field.hint.new_password": "പുതിയ പാസ്വേഡ്",
        "field.label.confirm_new_password": "പുതിയ പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക",
        "field.hint.confirm_new_password": "പുതിയ പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക",
        "field.label.confirm_password": "പാസ്വേഡ് സ്ഥിരീകരിക്കുക",
        "field.label.Enter_otp": "രജിസ്റ്റർ ചെയ്ത മൊബൈൽ നമ്പറിൽ/ഇമെയിലിൽ അയച്ച 6 അക്ക ഒറ്റത്തവണ പാസ്‌വേഡ് (OTP) നൽകുക.",
        "field.label.enter_otp": "ബന്ധപ്പെടാനുള്ള വിശദാംശങ്ങൾ പരിശോധിക്കുന്നതിനായി ഞങ്ങൾ നിങ്ങളുടെ മൊബൈലിൽ 6 അക്ക പരിശോധനാ കോഡ് അയച്ചിട്ടുണ്ട്.",
        "field.label.Enter_OTP": "രജിസ്റ്റർ ചെയ്ത മൊബൈൽ നമ്പറിൽ അയച്ച 6 അക്ക ഒറ്റത്തവണ പാസ്‌വേഡ് (OTP) നൽകുക.",
        "field.label.resend_code": "കോഡ് വീണ്ടും അയക്കുക",
        "field.label.resend_OTP": "OTP വീണ്ടും അയയ്‌ക്കുക",
        "field.label.invalid_otp": "അസാധുവായ OTP",
        "field.label.invalid_user": "അസാധുവായ ഉപയോക്താവ്",
        "field.label.seconds": "സെക്കന്റ്",
        "field.label.UHID": "UHID",
        "field.label.resend_OTP_in_timer_sec": "OTP വീണ്ടും അയയ്ക്കുക",
        "field.label.mobile_number_digits.": "മൊബൈൽ നമ്പർ 10 അക്കങ്ങളിൽ കുറവായിരിക്കരുത്.",
        "field.label.alphabet_cannot_be_accepted": "അക്ഷരമാല അംഗീകരിക്കാനാവില്ല",
        "field.label.login_cannot_be_2": "ലോഗിൻ ഐഡി 2 പ്രതീകത്തിൽ കുറവായിരിക്കരുത്.",
        "field.label.account_Url_required": "അക്കൗണ്ട് യുആർഎല്ലിന് കുറഞ്ഞത് 2 പ്രതീകങ്ങൾ ആവശ്യമാണ്.",
        "field.label.account_Url_not_exceed": "അക്കൗണ്ട് യുആർഎൽ 255 പ്രതീകങ്ങളിൽ കൂടരുത്.",
        "field.label.only_alphabet_hyphen_dot_numbers": "അക്ഷരമാല, ഹൈഫൻ, ഡോട്ട്, അക്കങ്ങൾ എന്നിവ മാത്രമേ അനുവദിക്കൂ.",
        "field.label.password_cannot_be_6": "പാസ്‌വേഡ് 6 പ്രതീകങ്ങളിൽ കുറവായിരിക്കരുത്.",
        "field.label.confirm_password_required": "പാസ്‌വേഡ് സ്ഥിരീകരിക്കേണ്ടത് ആവശ്യമാണ്",
        "field.label.passwords_match": "നിങ്ങളുടെ പാസ്‌വേഡുകൾ പൊരുത്തപ്പെടുന്നുണ്ടെന്ന് ഉറപ്പാക്കുക",
        "field.label.type_the_characters": "മുകളിൽ അക്ഷരങ്ങൾ ടൈപ്പ് ചെയ്യുക:",
        "field.label.captcha_is_required": "ക്യാപ്ച ആവശ്യമാണ്",
        "field.label.required.password": "പാസ്‌വേഡ് ആവശ്യമാണ്",
        "button.change_password": "പാസ്വേഡ് മാറ്റുക",
        "field.label.please_turn_on_notification": "മികച്ച അനുഭവത്തിനായി അറിയിപ്പ് ഓണാക്കുക",
        "dam": "നിങ്ങളുടെ അഡ്‌മിനിസ്‌ട്രേറ്ററെ ബന്ധപ്പെടുകയും ഈ ഉപകരണത്തിന് അംഗീകാരം നേടുകയും ചെയ്യുക.",
        "button.manage_user_pin": "പിൻ സൃഷ്ടിക്കുക",
        "button.update_landing_url": "ലാൻഡിംഗ് യുആർഎൽ അപ്ഡേറ്റ് ചെയ്യുക",
        "button.support": "പിന്തുണ",
        "pagename.list.setDefaultFacility": "സ്ഥിരസ്ഥിതി സൗകര്യം സജ്ജമാക്കുക",
        "button.check_my_internet_speed": "എന്റെ ഇന്റർനെറ്റ് വേഗത പരിശോധിക്കുക",
        "button.check_screen_shortcuts": "കുറുക്കുവഴി കീകൾ",
        "button.install_app": "ആപ്പ് ഇൻസ്റ്റാൾ ചെയ്യുക",
        "button.logout": "പുറത്തുകടക്കുക",
        "field.hint.search_menu": "തിരയൽ മെനു",
        "button.change_login_id": "ലോഗിൻ ഐഡി മാറ്റുക",
        "field.label.search_role": "തിരയൽ റോൾ",
        "field.label.quick_otp": "രജിസ്റ്റർ ചെയ്ത ഇമെയിലിൽ അയച്ച 6 അക്ക ഒറ്റത്തവണ പാസ്‌വേഡ് (OTP) നൽകുക.",
        "field.label.quick_download_verification_code": "ഡൗൺലോഡ് തുടരാൻ സ്ഥിരീകരണ കോഡ് നൽകുക...",
        "nto": "നെറ്റ്‌വർക്ക് കാലഹരണപ്പെട്ടു, നിങ്ങളുടെ ഇന്റർനെറ്റ് കണക്ഷൻ പരിശോധിക്കുക.",
        "cffe": "CSV ഫോർമാറ്റ് ചെയ്യുമ്പോൾ പിശക്",
        "idnf": "ഡൗൺലോഡ് കണ്ടെത്തിയില്ല",
        "otpsuc": "നിങ്ങളുടെ രജിസ്റ്റർ ചെയ്ത ഇമെയിലിൽ OTP വിജയകരമായി അയച്ചു.",
        "field.label.enter_otp_normal": "OTP നൽകുക"
    },
    es: {
        "field.label.login_id": "Ingresar identificación",
        "field.label.password": "Contraseña",
        "button.label.login": "Acceso",
        "field.label.sign_in": "Acceso",
        "field.label.forgot_password": "Has olvidado tu contraseña",
        "field.label.patient_login_with_mobile": "Iniciar sesión con OTP",
        "field.label.terms_of_service": "Términos de servicio",
        "field.label.new_to_the_platform": "¿Nuevo en la plataforma?",
        "field.label.sign_up": "Registrar nuevo usuario",
        "field.label.account_url": "URL de la cuenta",
        "field.label.check_app_status": "Verifique el estado de la aplicación.",
        "field.label.new_user_registration": "Registro de nuevo usuario",
        "field.label.click_hare_for_new_user_registration": "Haga clic aquí para un nuevo registro",
        "field.label.install_lite_app": "Instalar la aplicación lite",
        "field.label.full_name": "Nombre completo",
        "field.label.mobilenumber": "Número de teléfono móvil",
        "field.label.accounturl": "URL de la cuenta",
        "button.label.next": "Próximo",
        "field.label.email_address": "Dirección de correo electrónico",
        "field.label.reset_password": "Restablecer la contraseña",
        "button.generate_otp": "Generar OTP",
        "field.label.select": "Seleccionar",
        "field.hint.old_password": "Ingrese la contraseña anterior",
        "button.cancel": "Cancelar",
        "button.update": "Actualizar",
        "field.label.mobile_number": "Número de teléfono móvil",
        "field.label.new_password": "Nueva contraseña",
        "field.label.old_password": "Contraseña anterior",
        "field.hint.new_password": "Nueva contraseña",
        "field.label.confirm_new_password": "Confirmar nueva contraseña",
        "field.hint.confirm_new_password": "Confirmar nueva contraseña",
        "field.label.confirm_password": "confirmar Contraseña",
        "field.label.Enter_otp": "Ingrese la contraseña de un solo uso (OTP) de 6 dígitos enviada al número de teléfono móvil/correo electrónico registrado.",
        "field.label.enter_otp": "Le hemos enviado un código de verificación de 6 dígitos a su teléfono móvil para verificar los datos de contacto.",
        "field.label.Enter_OTP": "Ingrese la contraseña de un solo uso (OTP) de 6 dígitos enviada al número de teléfono móvil registrado.",
        "field.label.resend_code": "Reenviar codigo",
        "field.label.resend_OTP": "Reenviar OTP",
        "field.label.invalid_otp": "OTP no válida",
        "field.label.invalid_user": "usuario invalido",
        "field.label.seconds": "segundo",
        "field.label.UHID": "uhid",
        "field.label.resend_OTP_in_timer_sec": "Reenviar OTP en",
        "field.label.mobile_number_digits.": "El número de móvil no puede tener menos de 10 dígitos.",
        "field.label.alphabet_cannot_be_accepted": "No se puede aceptar el alfabeto.",
        "field.label.login_cannot_be_2": "El ID de inicio de sesión no puede tener menos de 2 caracteres.",
        "field.label.account_Url_required": "La URL de la cuenta requiere al menos 2 caracteres.",
        "field.label.account_Url_not_exceed": "La URL de la cuenta no puede exceder los 255 caracteres.",
        "field.label.only_alphabet_hyphen_dot_numbers": "Sólo se permiten letras, guiones, puntos y números.",
        "field.label.password_cannot_be_6": "La contraseña no puede tener menos de 6 caracteres.",
        "field.label.confirm_password_required": "Confirmar Se requiere contraseña",
        "field.label.passwords_match": "Por favor, asegúrese de que sus contraseñas coinciden",
        "field.label.type_the_characters": "Escriba los caracteres de arriba:",
        "field.label.captcha_is_required": "Se requiere captcha",
        "field.label.required.password": "Se requiere contraseña",
        "button.change_password": "Cambiar la contraseña",
        "field.label.please_turn_on_notification": "Para una mejor experiencia, activa la notificación.",
        "dam": "Comuníquese con su administrador y obtenga la aprobación de este dispositivo.",
        "button.manage_user_pin": "Generar PIN",
        "button.update_landing_url": "Actualizar URL de destino",
        "button.support": "Apoyo",
        "pagename.list.setDefaultFacility": "Establecer instalación predeterminada",
        "button.check_my_internet_speed": "Comprobar mi velocidad de Internet",
        "button.check_screen_shortcuts": "Teclas de atajo",
        "button.install_app": "Instalar aplicación",
        "button.logout": "Cerrar sesión",
        "field.hint.search_menu": "Menú de búsqueda",
        "button.change_login_id": "Cambiar ID de inicio de sesión",
        "field.label.search_role": "Función de búsqueda",
        "field.label.quick_otp": "Ingrese la contraseña de un solo uso (OTP) de 6 dígitos enviada en el correo electrónico registrado.",
        "field.label.quick_download_verification_code": "Ingrese el código de verificación para continuar Descargar...",
        "nto": "Tiempo de espera de la red. Verifique su conexión a Internet.",
        "cffe": "Error al formatear el CSV",
        "idnf": "Descarga no encontrada",
        "otpsuc": "OTP enviada exitosamente a su correo electrónico registrado.",
        "field.label.enter_otp_normal": "Ingrese la OTP"
    }
}

